
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire34b5"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire34b5"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("4PDzO", function(module, exports) {
$parcel$export(module.exports, "UsageBasedPricingPage", function () { return $227f5787b6c960f5$export$c6f5b237bddf4246; });
/* usage-based-pricing-page.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $jqAsR = parcelRequire("jqAsR");

var $c9P0g = parcelRequire("c9P0g");

var $ecTCn = parcelRequire("ecTCn");

var $grcEk = parcelRequire("grcEk");

var $kbpa7 = parcelRequire("kbpa7");

var $hcVGp = parcelRequire("hcVGp");
const $227f5787b6c960f5$export$c6f5b237bddf4246 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $grcEk.PricingPageLayout), {
        nav: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hcVGp.GlobalNav), {
            productKey: "usage-based-pricing"
        }),
        noInlinePadding: true,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jqAsR.UbpContextProvider), {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)($227f5787b6c960f5$var$UsageBasedPricingShell, {})
        })
    });
};
/**
 * Inner shell — sits inside PricingPageLayout's <main>. Renders the header,
 * the calculator state-machine driven step view, and the legacy wizard
 * (industry/team-size/growth/feature/solution + capacity sidebar) so behaviour
 * is preserved while the new Q4 calculator is rolled out.
 */ const $227f5787b6c960f5$var$UsageBasedPricingShell = ()=>{
    const loadData = (0, $c9P0g.useLoadProductCatalogData)();
    (0, $1oC0p.useEffect)(()=>{
        loadData();
    }, [
        loadData
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_kqswh2mm _1bsb1osq _1reo15vq _18m915vq _bfhk1afi _2rkogktf _1q51idpf _85i51jfw _xc2iidpf _144txy5q _1l9u7vkz _1u2qidpf _xlt11ejb _a5zt1crf"
        ]),
        style: {
            "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_kqswh2mm _1pbykb7n _1e0c1txw _2lx21bp4 _zulp1jfw _1bsb1osq _p12ftfvk _195g1wug _18zridpf _7se21wqb _2osnxy5q _1bhl1wqb _81641ejb _s51szwfg"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
                "aria-label": "Usage-based pricing calculator",
                "data-testid": "ubp-calculator-shell",
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx21bp4 _4cvr1h6o _zulpxy5q _1bsb1osq"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ecTCn.UsageBasedPricingCalculator), {})
            })
        })
    });
};
/**
 * Outer container. Provides a flat white background for the calculator
 * viewport.
 */ const $227f5787b6c960f5$var$shellBackgroundStyles = null;
const $227f5787b6c960f5$var$shellInnerStyles = null;
/**
 * Step layout wrapper — every calculator step renders inside this so the
 * spacing rhythm, max-width, and inline padding are consistent across the
 * usage / needs / estimate / allowance / summary steps.
 */ const $227f5787b6c960f5$var$stepLayoutStyles = null;

});
parcelRegister("jqAsR", function(module, exports) {
$parcel$export(module.exports, "UbpStep", function () { return $906b47b2676ba510$export$23963b701e0b1ed; });
$parcel$export(module.exports, "useUbpContext", function () { return $906b47b2676ba510$export$dc0276ea3fe966fa; });
$parcel$export(module.exports, "UbpContextProvider", function () { return $906b47b2676ba510$export$17c668f0eddf3669; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");
var $906b47b2676ba510$export$23963b701e0b1ed = /*#__PURE__*/ function(UbpStep) {
    UbpStep[UbpStep["collections"] = 0] = "collections";
    UbpStep[UbpStep["orgChangePercent"] = 1] = "orgChangePercent";
    UbpStep[UbpStep["usageEstimate"] = 2] = "usageEstimate";
    UbpStep[UbpStep["plans"] = 3] = "plans";
    return UbpStep;
}({});
const $906b47b2676ba510$var$UbpContext = /*#__PURE__*/ (0, $1oC0p.createContext)(undefined);
const $906b47b2676ba510$export$dc0276ea3fe966fa = ()=>{
    const ctx = (0, $1oC0p.useContext)($906b47b2676ba510$var$UbpContext);
    if (!ctx) throw new Error('missing context provider for UbpContext');
    return ctx;
};
const $906b47b2676ba510$var$defaultCollections = {
    teamwork: {
        selected: false,
        plan: 'premium'
    },
    strategy: {
        selected: false,
        plan: 'premium'
    },
    service: {
        selected: false,
        plan: 'premium'
    },
    software: {
        selected: false,
        plan: 'premium'
    }
};
const $906b47b2676ba510$var$DEFAULT_ORG_CHANGE_PERCENT = 1;
const $906b47b2676ba510$var$DEFAULT_ORG_USER_COUNT = 0;
const $906b47b2676ba510$var$DEFAULT_CHAT_ADOPTION_PERCENT = 0;
const $906b47b2676ba510$var$DEFAULT_CHAT_USERS_PER_RULE_PER_MONTH = 0;
const $906b47b2676ba510$var$DEFAULT_AUTOMATION_ACTIVE_RULES = 0;
const $906b47b2676ba510$var$DEFAULT_AUTOMATION_RUNS_PER_RULE_PER_MONTH = 0;
const $906b47b2676ba510$var$DEFAULT_STEP = 0;
const $906b47b2676ba510$export$17c668f0eddf3669 = (props)=>{
    const [collections, setCollections] = (0, $1oC0p.useState)($906b47b2676ba510$var$defaultCollections);
    const [orgChangePercent, setOrgChangePercent] = (0, $1oC0p.useState)($906b47b2676ba510$var$DEFAULT_ORG_CHANGE_PERCENT);
    const [orgUserCount, setOrgUserCount] = (0, $1oC0p.useState)($906b47b2676ba510$var$DEFAULT_ORG_USER_COUNT);
    const [chatAdoptionPercent, setChatAdoptionPercent] = (0, $1oC0p.useState)($906b47b2676ba510$var$DEFAULT_CHAT_ADOPTION_PERCENT);
    const [chatUsersPerRulePerMonth, setChatUsersPerRulePerMonth] = (0, $1oC0p.useState)($906b47b2676ba510$var$DEFAULT_CHAT_USERS_PER_RULE_PER_MONTH);
    const [automationActiveRules, setAutomationActiveRules] = (0, $1oC0p.useState)($906b47b2676ba510$var$DEFAULT_AUTOMATION_ACTIVE_RULES);
    const [automationRunsPerRulePerMonth, setAutomationRunsPerRulePerMonth] = (0, $1oC0p.useState)($906b47b2676ba510$var$DEFAULT_AUTOMATION_RUNS_PER_RULE_PER_MONTH);
    const [step, setStep] = (0, $1oC0p.useState)($906b47b2676ba510$var$DEFAULT_STEP);
    const [productCatalog, setProductCatalog] = (0, $1oC0p.useState)({
        loading: false,
        data: null,
        error: null
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)($906b47b2676ba510$var$UbpContext.Provider, {
        value: {
            inputs: {
                values: {
                    collections: collections,
                    orgChangePercent: orgChangePercent,
                    orgUserCount: orgUserCount,
                    chatAdoptionPercent: chatAdoptionPercent,
                    chatUsersPerRulePerMonth: chatUsersPerRulePerMonth,
                    automationActiveRules: automationActiveRules,
                    automationRunsPerRulePerMonth: automationRunsPerRulePerMonth
                },
                setters: {
                    setCollections: setCollections,
                    setOrgChangePercent: setOrgChangePercent,
                    setOrgUserCount: setOrgUserCount,
                    setChatAdoptionPercent: setChatAdoptionPercent,
                    setChatUsersPerRulePerMonth: setChatUsersPerRulePerMonth,
                    setAutomationActiveRules: setAutomationActiveRules,
                    setAutomationRunsPerRulePerMonth: setAutomationRunsPerRulePerMonth
                }
            },
            step: step,
            setStep: setStep,
            productCatalog: productCatalog,
            setProductCatalog: setProductCatalog
        },
        children: props.children
    });
};

});

parcelRegister("c9P0g", function(module, exports) {
$parcel$export(module.exports, "useLoadProductCatalogData", function () { return $10c0b7f18a2b08eb$export$a66d0c686a571ba1; });

var $1oC0p = parcelRequire("1oC0p");

var $8KOLZ = parcelRequire("8KOLZ");

var $b6hbg = parcelRequire("b6hbg");

var $jqAsR = parcelRequire("jqAsR");

var $2LoaG = parcelRequire("2LoaG");

var $9dz7i = parcelRequire("9dz7i");
const $10c0b7f18a2b08eb$export$d4684c44411706d4 = ()=>(0, $jqAsR.useUbpContext)().inputs.values;
const $10c0b7f18a2b08eb$export$dc86fcdb557baa79 = ()=>(0, $jqAsR.useUbpContext)().inputs.setters;
const $10c0b7f18a2b08eb$export$7896576cb7635832 = ()=>(0, $jqAsR.useUbpContext)().step;
const $10c0b7f18a2b08eb$export$5fbef6a33fc3ef44 = ()=>(0, $jqAsR.useUbpContext)().setStep;
const $10c0b7f18a2b08eb$export$ed483cbd896dc262 = ()=>{
    const { collections: collections } = $10c0b7f18a2b08eb$export$d4684c44411706d4();
    return Object.values(collections).some((c)=>c.selected);
};
const $10c0b7f18a2b08eb$export$59873a11f4f97de3 = ()=>{
    const { setCollections: setCollections } = $10c0b7f18a2b08eb$export$dc86fcdb557baa79();
    return (0, $1oC0p.useCallback)((key, selected)=>{
        setCollections((prev)=>({
                ...prev,
                [key]: {
                    ...prev[key],
                    selected: selected
                }
            }));
    }, [
        setCollections
    ]);
};
const $10c0b7f18a2b08eb$export$cd9e4631f4963434 = ()=>{
    const { setCollections: setCollections } = $10c0b7f18a2b08eb$export$dc86fcdb557baa79();
    return (0, $1oC0p.useCallback)((key, plan)=>{
        setCollections((prev)=>({
                ...prev,
                [key]: {
                    ...prev[key],
                    plan: plan
                }
            }));
    }, [
        setCollections
    ]);
};
const $10c0b7f18a2b08eb$export$9eee33855d10180c = ()=>{
    const inputs = $10c0b7f18a2b08eb$export$d4684c44411706d4();
    return (0, $1oC0p.useMemo)(()=>(0, $2LoaG.calculateUsage)(inputs), [
        inputs
    ]);
};
const $10c0b7f18a2b08eb$export$39880f96d7051909 = ()=>{
    const usage = $10c0b7f18a2b08eb$export$9eee33855d10180c();
    const allowances = $10c0b7f18a2b08eb$export$f4470fb8fc59b1a1();
    const step = $10c0b7f18a2b08eb$export$7896576cb7635832();
    if (step === (0, $jqAsR.UbpStep).collections) return false;
    return usage.aiCredits > allowances.aiCredits;
};
const $10c0b7f18a2b08eb$export$f4470fb8fc59b1a1 = ()=>{
    const inputs = $10c0b7f18a2b08eb$export$d4684c44411706d4();
    const allowanceConfigs = $10c0b7f18a2b08eb$export$a1b9af7912387f4f();
    return (0, $1oC0p.useMemo)(()=>{
        if (!allowanceConfigs) return {
            aiCredits: 0,
            indexedObjects: 0
        };
        const allowances = (0, $2LoaG.calculateAllowances)({
            allowanceConfigs: allowanceConfigs,
            inputs: {
                ...inputs,
                offeringSkus: $10c0b7f18a2b08eb$var$collectionsToSkus(inputs.collections)
            }
        });
        return {
            ...allowances
        };
    }, [
        inputs
    ]);
};
const $10c0b7f18a2b08eb$var$COLLECTION_SKU_MAP = {
    teamwork: {
        free: (0, $9dz7i.skus).teamworkCollectionFree,
        standard: (0, $9dz7i.skus).teamworkCollectionStandard,
        premium: (0, $9dz7i.skus).teamworkCollectionPremium,
        enterprise: (0, $9dz7i.skus).teamworkCollectionEnterprise
    },
    service: {
        free: (0, $9dz7i.skus).serviceCollectionFree,
        standard: (0, $9dz7i.skus).serviceCollectionStandard,
        premium: (0, $9dz7i.skus).serviceCollectionPremium,
        enterprise: (0, $9dz7i.skus).serviceCollectionEnterprise
    },
    strategy: {
        free: (0, $9dz7i.skus).teamworkCollectionFree,
        standard: (0, $9dz7i.skus).teamworkCollectionStandard,
        premium: (0, $9dz7i.skus).teamworkCollectionPremium,
        enterprise: (0, $9dz7i.skus).teamworkCollectionEnterprise
    },
    software: {
        free: (0, $9dz7i.skus).teamworkCollectionFree,
        standard: (0, $9dz7i.skus).teamworkCollectionStandard,
        premium: (0, $9dz7i.skus).teamworkCollectionPremium,
        enterprise: (0, $9dz7i.skus).teamworkCollectionEnterprise
    }
};
const $10c0b7f18a2b08eb$var$collectionsToSkus = (collections)=>{
    return Object.keys(collections).filter((key)=>collections[key].selected).map((key)=>$10c0b7f18a2b08eb$var$COLLECTION_SKU_MAP[key][collections[key].plan]);
};
const $10c0b7f18a2b08eb$export$a66d0c686a571ba1 = ()=>{
    const { setProductCatalog: setProductCatalog } = (0, $jqAsR.useUbpContext)();
    const fireAnalyticsEvent = (0, $8KOLZ.useFireAnalyticsEvents)();
    // `useFireAnalyticsEvents` returns a fresh object literal every render, so
    // including it directly in the useCallback dependency array would cause the
    // returned function to change identity every render — which breaks any
    // consumer that puts this function in a useEffect dependency array
    // (infinite render loop: effect fires → setState → re-render → new fn ref
    // → effect fires again). Stash the latest value in a ref so the callback
    // can read the current `fireAnalyticsEvent` without depending on it.
    const fireAnalyticsEventRef = (0, $1oC0p.useRef)(fireAnalyticsEvent);
    fireAnalyticsEventRef.current = fireAnalyticsEvent;
    // Only depend on the truly stable `setProductCatalog` (from useState). This
    // gives the returned function a stable identity across renders, safe to
    // pass into a useEffect dependency array.
    return (0, $1oC0p.useCallback)(async function loadProductCatalogData() {
        setProductCatalog({
            loading: true,
            data: null,
            error: null
        });
        try {
            const data = await (0, $b6hbg.fetchProductCatalogData)(Object.values((0, $9dz7i.skus)));
            setProductCatalog({
                loading: false,
                data: data,
                error: null
            });
        } catch (error) {
            setProductCatalog({
                loading: false,
                data: (0, $9dz7i.offeringAllowances),
                error: null
            });
            const errorData = error;
            fireAnalyticsEventRef.current.fireOperationalEvent({
                action: 'failed',
                actionSubject: 'ubpProductCatalogDataFetch',
                attributes: {
                    errorMessage: errorData?.message
                }
            });
        }
    }, [
        setProductCatalog
    ]);
};
const $10c0b7f18a2b08eb$export$a52f278dd718031f = ()=>{
    const { productCatalog: productCatalog } = (0, $jqAsR.useUbpContext)();
    return !productCatalog.loading && !!productCatalog.data;
};
const $10c0b7f18a2b08eb$export$a1b9af7912387f4f = ()=>{
    return (0, $jqAsR.useUbpContext)().productCatalog.data;
};

});
parcelRegister("b6hbg", function(module, exports) {
$parcel$export(module.exports, "fetchProductCatalogData", function () { return $2efafce82afd6fa3$export$8d271a5aff84d3c5; });

var $61WdP = parcelRequire("61WdP");

var $aZFKp = parcelRequire("aZFKp");

var $cYm2M = parcelRequire("cYm2M");
const $2efafce82afd6fa3$export$8d271a5aff84d3c5 = async (offeringSKUs)=>{
    const client = (0, $61WdP.getContentfulProductCatalogClient)();
    const offerings = await client.getCCPPricingData(offeringSKUs);
    const data = (0, $aZFKp.transform)(offerings);
    (0, $cYm2M.validate)(data);
    return data;
};

});
parcelRegister("aZFKp", function(module, exports) {
$parcel$export(module.exports, "transform", function () { return $47dee04aa7a99b03$export$51186ad6e864892a; });
const $47dee04aa7a99b03$var$USAGE_KEY_MAP = {
    'ai-credit': 'aiCredit',
    'indexed-document': 'indexedDocument'
};
const $47dee04aa7a99b03$var$CYCLE_MAP = {
    MONTHLY: 'monthly',
    ANNUAL: 'annual'
};
const $47dee04aa7a99b03$export$51186ad6e864892a = (offerings)=>{
    const result = {};
    for (const [sku, offering] of Object.entries(offerings)){
        const allowance = {
            aiCredit: {
                monthly: 0,
                annual: 0
            },
            indexedDocument: {
                monthly: 0,
                annual: 0
            }
        };
        const features = offering?.entitlementTemplate_data?.features ?? [];
        for (const feature of features)$47dee04aa7a99b03$var$applyFeatureAllowances(allowance, feature.value?.allowances ?? []);
        result[sku] = allowance;
    }
    return result;
};
const $47dee04aa7a99b03$var$applyCycles = (target, cycles)=>{
    for (const cycle of cycles){
        const period = $47dee04aa7a99b03$var$CYCLE_MAP[cycle.cycle];
        if (period) target[period] += cycle.amount;
    }
};
const $47dee04aa7a99b03$var$applyFeatureAllowances = (allowance, featureAllowances)=>{
    for (const featureAllowance of featureAllowances){
        const usageKey = featureAllowance.config?.usageKey;
        const mappedKey = usageKey ? $47dee04aa7a99b03$var$USAGE_KEY_MAP[usageKey] : undefined;
        if (!mappedKey) continue;
        $47dee04aa7a99b03$var$applyCycles(allowance[mappedKey], featureAllowance.config?.cycles ?? []);
    }
};

});

parcelRegister("cYm2M", function(module, exports) {
$parcel$export(module.exports, "validate", function () { return $80a88424659fce82$export$a22775fa5e2eebd9; });

var $9dz7i = parcelRequire("9dz7i");
const $80a88424659fce82$var$allSkus = Object.values((0, $9dz7i.skus));
function $80a88424659fce82$export$a22775fa5e2eebd9(data) {
    if (typeof data !== 'object' || data === null || Array.isArray(data)) throw new Error(`Invalid product catalog data: expected a non-null object, got ${data === null ? 'null' : Array.isArray(data) ? 'array' : typeof data}`);
    const record = data;
    const missingSku = $80a88424659fce82$var$allSkus.find((sku)=>!(sku in record));
    if (missingSku !== undefined) throw new Error(`Invalid product catalog data: missing entry for SKU "${missingSku}"`);
    for (const sku of $80a88424659fce82$var$allSkus){
        if (!$80a88424659fce82$var$isOfferingAllowance(record[sku])) throw new Error(`Invalid product catalog data: entry for SKU "${sku}" does not match OfferingAllowance shape`);
    }
}
function $80a88424659fce82$var$isOfferingAllowance(value) {
    if (typeof value !== 'object' || value === null) return false;
    const v = value;
    for (const field of [
        'aiCredit',
        'indexedDocument'
    ]){
        const entry = v[field];
        if (typeof entry !== 'object' || entry === null) return false;
        const e = entry;
        if (typeof e['monthly'] !== 'number' || typeof e['annual'] !== 'number') return false;
    }
    return true;
}

});
parcelRegister("9dz7i", function(module, exports) {
$parcel$export(module.exports, "skus", function () { return $e10d629d1810f0d9$export$51ba92eeb7158b57; });
$parcel$export(module.exports, "AI_CREDITS_PER_USER_INTERACTION", function () { return $e10d629d1810f0d9$export$de7390b8b3586c9a; });
$parcel$export(module.exports, "AI_CREDITS_PER_AUTOMATION", function () { return $e10d629d1810f0d9$export$6a6dda0c3d52963c; });
$parcel$export(module.exports, "offeringAllowances", function () { return $e10d629d1810f0d9$export$27e361dea74e34b2; });
const $e10d629d1810f0d9$export$51ba92eeb7158b57 = {
    teamworkCollectionFree: 'teamwork-collection-free-sku',
    teamworkCollectionStandard: 'teamwork-collection-standard-sku',
    teamworkCollectionPremium: 'teamwork-collection-premium-sku',
    teamworkCollectionEnterprise: 'teamwork-collection-enterprise-sku',
    serviceCollectionFree: 'service-collection-free',
    serviceCollectionStandard: 'service-collection-standard',
    serviceCollectionPremium: 'service-collection-premium',
    serviceCollectionEnterprise: 'service-collection-enterprise'
};
const $e10d629d1810f0d9$export$de7390b8b3586c9a = 20;
const $e10d629d1810f0d9$export$6a6dda0c3d52963c = 20;
const $e10d629d1810f0d9$export$27e361dea74e34b2 = {
    [$e10d629d1810f0d9$export$51ba92eeb7158b57.teamworkCollectionFree]: {
        aiCredit: {
            monthly: 0,
            annual: 0
        },
        indexedDocument: {
            monthly: 0,
            annual: 0
        }
    },
    [$e10d629d1810f0d9$export$51ba92eeb7158b57.teamworkCollectionStandard]: {
        aiCredit: {
            monthly: 250,
            annual: 250
        },
        indexedDocument: {
            monthly: 1000,
            annual: 1000
        }
    },
    [$e10d629d1810f0d9$export$51ba92eeb7158b57.teamworkCollectionPremium]: {
        aiCredit: {
            monthly: 700,
            annual: 700
        },
        indexedDocument: {
            monthly: 2500,
            annual: 2500
        }
    },
    [$e10d629d1810f0d9$export$51ba92eeb7158b57.teamworkCollectionEnterprise]: {
        aiCredit: {
            monthly: 1500,
            annual: 1500
        },
        indexedDocument: {
            monthly: 6250,
            annual: 6250
        }
    },
    [$e10d629d1810f0d9$export$51ba92eeb7158b57.serviceCollectionFree]: {
        aiCredit: {
            monthly: 0,
            annual: 0
        },
        indexedDocument: {
            monthly: 0,
            annual: 0
        }
    },
    [$e10d629d1810f0d9$export$51ba92eeb7158b57.serviceCollectionStandard]: {
        aiCredit: {
            monthly: 25,
            annual: 25
        },
        indexedDocument: {
            monthly: 100,
            annual: 100
        }
    },
    [$e10d629d1810f0d9$export$51ba92eeb7158b57.serviceCollectionPremium]: {
        aiCredit: {
            monthly: 70,
            annual: 70
        },
        indexedDocument: {
            monthly: 250,
            annual: 250
        }
    },
    [$e10d629d1810f0d9$export$51ba92eeb7158b57.serviceCollectionEnterprise]: {
        aiCredit: {
            monthly: 150,
            annual: 150
        },
        indexedDocument: {
            monthly: 625,
            annual: 625
        }
    }
};

});



parcelRegister("2LoaG", function(module, exports) {
$parcel$export(module.exports, "calculateAllowances", function () { return $432c0661cb02a854$export$1ddd1a64f8973b2b; });
$parcel$export(module.exports, "calculateUsage", function () { return $432c0661cb02a854$export$48a9b49eebf17443; });

var $9dz7i = parcelRequire("9dz7i");
function $432c0661cb02a854$export$1ddd1a64f8973b2b(args) {
    const { allowanceConfigs: allowanceConfigs, inputs: inputs } = args;
    const { offeringSkus: offeringSkus, orgChangePercent: orgChangePercent, orgUserCount: orgUserCount } = inputs;
    let aiCreditsSum = 0;
    let indexedObjectsSum = 0;
    for (const sku of offeringSkus){
        const config = allowanceConfigs[sku];
        if (!config) continue;
        aiCreditsSum += config.aiCredit.monthly * orgUserCount;
        indexedObjectsSum += config.indexedDocument.monthly * orgUserCount;
    }
    return {
        aiCredits: Math.round(aiCreditsSum * orgChangePercent)
    };
}
function $432c0661cb02a854$export$48a9b49eebf17443(args) {
    const { orgUserCount: orgUserCount, orgChangePercent: orgChangePercent, chatAdoptionPercent: chatAdoptionPercent, chatUsersPerRulePerMonth: chatUsersPerRulePerMonth, automationActiveRules: automationActiveRules, automationRunsPerRulePerMonth: automationRunsPerRulePerMonth } = args;
    const userInteractionCredits = orgUserCount * orgChangePercent * chatAdoptionPercent * chatUsersPerRulePerMonth * (0, $9dz7i.AI_CREDITS_PER_USER_INTERACTION);
    const automationCredits = automationActiveRules * automationRunsPerRulePerMonth * (0, $9dz7i.AI_CREDITS_PER_AUTOMATION);
    return {
        aiCredits: Math.round(userInteractionCredits + automationCredits)
    };
}

});


parcelRegister("ecTCn", function(module, exports) {
$parcel$export(module.exports, "UsageBasedPricingCalculator", function () { return $a9a1671730ec00f4$export$81c720f4667b8b84; });
/**
 * Root component: mounts the merged provider, fetches CCP pricing data up
 * front, and gates the wizard behind that fetch ("fetch first, then show the
 * experience").
 */ 
var $7VQPk = parcelRequire("7VQPk");

var $aTTpq = parcelRequire("aTTpq");

var $9wpUt = parcelRequire("9wpUt");

var $dEuk8 = parcelRequire("dEuk8");

var $jESEJ = parcelRequire("jESEJ");

var $hz9o6 = parcelRequire("hz9o6");

var $9lJTH = parcelRequire("9lJTH");

var $4xsw0 = parcelRequire("4xsw0");

var $hSUNh = parcelRequire("hSUNh");

var $bIpm5 = parcelRequire("bIpm5");
const $a9a1671730ec00f4$export$81c720f4667b8b84 = (props)=>{
    const initialValues = typeof window !== 'undefined' ? (0, $bIpm5.initialValuesFromQuery)(window.location.search) : undefined;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9lJTH.UbpContextProvider), {
        initialValues: initialValues,
        ...props,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)($a9a1671730ec00f4$var$UsageBasedPricingCalculatorInner, {})
    });
};
const $a9a1671730ec00f4$var$UsageBasedPricingCalculatorInner = ()=>{
    const pending = (0, $4xsw0.useSelector)((0, $hSUNh.isCcpDataPending));
    if (pending) return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: "Loading pricing data\u2026"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        style: $a9a1671730ec00f4$var$style,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)($a9a1671730ec00f4$var$CurrentStep, {})
    });
};
const $a9a1671730ec00f4$var$CurrentStep = ()=>{
    const step = (0, $4xsw0.useSelector)((0, $hSUNh.selectStep));
    switch(step){
        case 'usage':
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hz9o6.UsageStep), {});
        case 'needs':
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dEuk8.NeedsStep), {});
        case 'estimate':
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9wpUt.EstimateStep), {});
        case 'allowance':
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aTTpq.AllowanceStep), {});
        case 'summary':
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jESEJ.SummaryStep), {});
    }
};
const $a9a1671730ec00f4$var$style = {
    display: 'flex',
    flexDirection: 'column',
    // Gap removed — each step owns its own vertical rhythm via paddings on
    // headings and section wrappers, so the design matches Figma exactly
    // without a wrapper-level gap fighting explicit values.
    gap: 0,
    // All padding + auto-margins removed for this page. Horizontal centering
    // is done by the parent flex container (stepLayoutStyles uses
    // alignItems: center), so this element stays full-width up to maxWidth
    // without introducing left/right auto margins.
    padding: 0,
    margin: 0,
    width: '100%',
    maxWidth: 1100,
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif"
};

});
parcelRegister("aTTpq", function(module, exports) {
$parcel$export(module.exports, "AllowanceStep", function () { return $54ee61fb64dd615e$export$a67e8c2aef6e5372; });
/* allowance-step.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kbpa7 = parcelRequire("kbpa7");

var $4xsw0 = parcelRequire("4xsw0");

var $hSUNh = parcelRequire("hSUNh");

var $ahF4L = parcelRequire("ahF4L");

var $cNQe2 = parcelRequire("cNQe2");

var $ehiBJ = parcelRequire("ehiBJ");

var $cIZNT = parcelRequire("cIZNT");
const $54ee61fb64dd615e$export$a67e8c2aef6e5372 = ()=>{
    const initialTab = (0, $4xsw0.useSelector)((0, $hSUNh.selectInitialProductsTab));
    const [tab, setTab] = (0, $1oC0p.useState)(initialTab);
    const meter = (0, $4xsw0.useSelector)((0, $hSUNh.selectMeter));
    const canAdvance = (0, $4xsw0.useSelector)((0, $hSUNh.selectCanAdvanceAllowanceStep));
    const warningShown = (0, $4xsw0.useSelector)((0, $hSUNh.selectProductTabSelectionWarningShown));
    const changeTab = (0, $4xsw0.useChangeAllowanceTab)(tab, setTab);
    const APP_STRINGS = (0, $cNQe2.useAppDescriptions)();
    const COLLECTION_STRINGS = (0, $cNQe2.useCollectionDescriptions)();
    const appKeys = (0, $1oC0p.useMemo)(()=>Object.keys(APP_STRINGS), [
        APP_STRINGS
    ]);
    const collectionKeys = (0, $1oC0p.useMemo)(()=>Object.keys(COLLECTION_STRINGS), [
        COLLECTION_STRINGS
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cIZNT.Stepper), {}),
            /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                className: (0, $2jatx.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1wyb1k8s _k48p1fw0 _syazrf0c"
                ]),
                style: {
                    "--_ve8pbe": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light1100'))
                },
                children: "Allowance"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _zulpu2gc _179rn5xp"
                ]),
                style: {
                    "--_qtmnbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light300'))
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                        onClick: ()=>changeTab('collection'),
                        className: (0, $2jatx.default)([
                            "_1yt49l6b _1wyboxwj _k48pni7l _syaz1qc2 _80omtlke _19itglyw _bfhk1j28 _179r1vrj",
                            tab === 'collection' && "_syaz5hrz _179r1qgu"
                        ]),
                        style: {
                            "--_1fww9ud": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light800')),
                            "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
                        },
                        children: "Collections"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                        onClick: ()=>changeTab('app'),
                        className: (0, $2jatx.default)([
                            "_1yt49l6b _1wyboxwj _k48pni7l _syaz1qc2 _80omtlke _19itglyw _bfhk1j28 _179r1vrj",
                            tab === 'app' && "_syaz5hrz _179r1qgu"
                        ]),
                        style: {
                            "--_1fww9ud": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light800')),
                            "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
                        },
                        children: "Apps"
                    })
                ]
            }),
            tab === 'collection' ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _zulpxy5q _1bah1h6o _1n261g80"
                ]),
                children: collectionKeys.map((choice)=>{
                    const { lockupUrl: lockupUrl, description: description, list: list } = COLLECTION_STRINGS[choice];
                    return /*#__PURE__*/ (0, $7VQPk.jsx)($54ee61fb64dd615e$var$CollectionCard, {
                        productKey: choice,
                        lockupUrl: lockupUrl,
                        description: description,
                        list: list
                    }, `collections-${choice}`);
                })
            }) : /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c11p5 _yv0e1ckl _zulpxy5q _19d7hkll"
                ]),
                children: appKeys.map((choice)=>{
                    const { label: label, iconUrl: iconUrl, description: description } = APP_STRINGS[choice];
                    return /*#__PURE__*/ (0, $7VQPk.jsx)($54ee61fb64dd615e$var$AppCard, {
                        productKey: choice,
                        label: label,
                        iconUrl: iconUrl,
                        description: description,
                        hide: choice === 'jpd' && meter !== 'automations'
                    }, `apps-${choice}`);
                })
            }),
            warningShown && /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                className: (0, $2jatx.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1wyboxwj _k48pni7l _syaz1qc2"
                ]),
                style: {
                    "--_1fww9ud": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light800'))
                },
                children: tab === 'collection' ? 'One or more apps were deselected' : 'One or more collections were deselected'
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ehiBJ.StepNav), {
                showBack: true,
                showNext: true,
                showSkip: true,
                skipTo: "summary",
                nextDisabled: !canAdvance
            })
        ]
    });
};
const $54ee61fb64dd615e$var$AppCard = ({ productKey: productKey, label: label, iconUrl: iconUrl, description: description, hide: hide = false })=>{
    const isSelected = (0, $4xsw0.useSelector)((0, $hSUNh.selectIsProductSelected)(productKey));
    const toggle = (0, $4xsw0.useToggleProduct)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ahF4L.ChoiceCard), {
        inputType: "checkbox",
        value: productKey,
        selected: isSelected,
        onSelect: ()=>toggle(productKey, !isSelected),
        groupName: "group-apps",
        label: label,
        iconUrl: iconUrl,
        description: description,
        hide: hide
    });
};
const $54ee61fb64dd615e$var$CollectionCard = ({ productKey: productKey, lockupUrl: lockupUrl, description: description, list: list })=>{
    const isSelected = (0, $4xsw0.useSelector)((0, $hSUNh.selectIsProductSelected)(productKey));
    const toggle = (0, $4xsw0.useToggleProduct)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ahF4L.ChoiceCard), {
        inputType: "checkbox",
        value: productKey,
        selected: isSelected,
        onSelect: ()=>toggle(productKey, !isSelected),
        groupName: "group-collections",
        lockupUrl: lockupUrl,
        description: description,
        list: list
    });
};
const $54ee61fb64dd615e$var$stepTitleStyle = null;
const $54ee61fb64dd615e$var$tabsRowStyle = null;
const $54ee61fb64dd615e$var$tabStyle = null;
const $54ee61fb64dd615e$var$tabActiveStyle = null;
const $54ee61fb64dd615e$var$warningStyle = null;
const $54ee61fb64dd615e$var$cardRowStyle = null;
const $54ee61fb64dd615e$var$gridStyle = null;

});
parcelRegister("4xsw0", function(module, exports) {
$parcel$export(module.exports, "useSelector", function () { return $8fa95e6732429854$export$2105062e25df4afe; });
$parcel$export(module.exports, "useSetStep", function () { return $8fa95e6732429854$export$5fbef6a33fc3ef44; });
$parcel$export(module.exports, "useGoToNextStep", function () { return $8fa95e6732429854$export$4b216893d72ebc80; });
$parcel$export(module.exports, "useGoToPrevStep", function () { return $8fa95e6732429854$export$b300120c1380d28d; });
$parcel$export(module.exports, "useSetMeter", function () { return $8fa95e6732429854$export$4f3e1ecf83371c48; });
$parcel$export(module.exports, "useSetUsageType", function () { return $8fa95e6732429854$export$9ec5ebc9bad43cb7; });
$parcel$export(module.exports, "useSetUsage", function () { return $8fa95e6732429854$export$3fd4f1a3274debf1; });
$parcel$export(module.exports, "useSetOrgUserCount", function () { return $8fa95e6732429854$export$307b1513ee9fcb41; });
$parcel$export(module.exports, "useOrgUserCountErrorMessage", function () { return $8fa95e6732429854$export$28caaf198b922e93; });
$parcel$export(module.exports, "useChangeAllowanceTab", function () { return $8fa95e6732429854$export$bfb26c471dd1b389; });
$parcel$export(module.exports, "useToggleProduct", function () { return $8fa95e6732429854$export$def94a993d8009ff; });

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $cGx7y = parcelRequire("cGx7y");

var $iqmYR = parcelRequire("iqmYR");

var $73KXs = parcelRequire("73KXs");

var $9lJTH = parcelRequire("9lJTH");

var $hSUNh = parcelRequire("hSUNh");

var $5eLaZ = parcelRequire("5eLaZ");
const $8fa95e6732429854$export$2105062e25df4afe = (selector)=>selector((0, $9lJTH.useUbpContext)());
const $8fa95e6732429854$export$5fbef6a33fc3ef44 = ()=>{
    const { setStep: setStep } = (0, $9lJTH.useUbpContext)();
    return (0, $1oC0p.useCallback)((step)=>setStep(step), [
        setStep
    ]);
};
const $8fa95e6732429854$export$4b216893d72ebc80 = ()=>{
    const { step: step, setStep: setStep } = (0, $9lJTH.useUbpContext)();
    return (0, $1oC0p.useCallback)(()=>{
        const next = (0, $73KXs.STEP_ORDER)[(0, $73KXs.STEP_ORDER).indexOf(step) + 1];
        if (next) setStep(next);
    }, [
        step,
        setStep
    ]);
};
const $8fa95e6732429854$export$b300120c1380d28d = ()=>{
    const { step: step, setStep: setStep } = (0, $9lJTH.useUbpContext)();
    return (0, $1oC0p.useCallback)(()=>{
        const prev = (0, $73KXs.STEP_ORDER)[(0, $73KXs.STEP_ORDER).indexOf(step) - 1];
        if (prev) setStep(prev);
    }, [
        step,
        setStep
    ]);
};
const $8fa95e6732429854$export$4f3e1ecf83371c48 = ()=>{
    const { setMeter: setMeter } = (0, $9lJTH.useUbpContext)();
    return (0, $1oC0p.useCallback)((meter)=>setMeter(meter), [
        setMeter
    ]);
};
const $8fa95e6732429854$export$9ec5ebc9bad43cb7 = ()=>{
    const { setUsageType: setUsageType } = (0, $9lJTH.useUbpContext)();
    return (0, $1oC0p.useCallback)((usageType)=>setUsageType(usageType), [
        setUsageType
    ]);
};
const $8fa95e6732429854$export$3fd4f1a3274debf1 = ()=>{
    const { setUsage: setUsage } = (0, $9lJTH.useUbpContext)();
    return (0, $1oC0p.useCallback)((usage)=>setUsage(usage), [
        setUsage
    ]);
};
const $8fa95e6732429854$export$307b1513ee9fcb41 = ()=>{
    const { setOrgUserCount: setOrgUserCount, setOrgUserCountError: setOrgUserCountError } = (0, $9lJTH.useUbpContext)();
    return (0, $1oC0p.useCallback)((orgUserCount)=>{
        setOrgUserCountError((0, $5eLaZ.validateOrgUserCount)(orgUserCount));
        setOrgUserCount(orgUserCount);
    }, [
        setOrgUserCount,
        setOrgUserCountError
    ]);
};
const $8fa95e6732429854$export$28caaf198b922e93 = ()=>{
    const intl = (0, $8e22h.default)();
    const error = $8fa95e6732429854$export$2105062e25df4afe((0, $hSUNh.selectOrgUserCountError));
    if (!error) return undefined;
    const message = (0, $5eLaZ.orgUserCountErrorMessages)[error];
    return intl.formatMessage(message, {
        min: (0, $5eLaZ.ORG_USER_COUNT_MIN),
        max: (0, $5eLaZ.ORG_USER_COUNT_MAX)
    });
};
const $8fa95e6732429854$export$4fc48d5e08ee88df = ()=>{
    const update = $8fa95e6732429854$var$useUpdateProductInputs();
    return (0, $1oC0p.useCallback)((productKey, edition)=>update(productKey, {
            edition: edition,
            billingCycle: (0, $iqmYR.resolveBillingCycle)(productKey, edition)
        }), [
        update
    ]);
};
const $8fa95e6732429854$export$fc62b22dc158a1c1 = ()=>{
    const update = $8fa95e6732429854$var$useUpdateProductInputs();
    return (0, $1oC0p.useCallback)((productKey, unitCount)=>update(productKey, {
            unitCount: unitCount
        }), [
        update
    ]);
};
const $8fa95e6732429854$export$3cfff81176298bbc = ()=>{
    const { setProducts: setProducts } = (0, $9lJTH.useUbpContext)();
    return (0, $1oC0p.useCallback)((productKey)=>{
        setProducts((prev)=>prev.some((product)=>product.productKey === productKey) ? prev : [
                ...prev,
                (0, $9lJTH.buildDefaultProduct)(productKey)
            ]);
    }, [
        setProducts
    ]);
};
const $8fa95e6732429854$export$7046da6c329e2110 = ()=>{
    const { setProducts: setProducts } = (0, $9lJTH.useUbpContext)();
    return (0, $1oC0p.useCallback)(()=>setProducts([]), [
        setProducts
    ]);
};
const $8fa95e6732429854$export$bfb26c471dd1b389 = (tab, setTab)=>{
    const { setProductTabSelectionWarningShown: setProductTabSelectionWarningShown } = (0, $9lJTH.useUbpContext)();
    const hasSelections = $8fa95e6732429854$export$2105062e25df4afe((0, $hSUNh.selectCategoryHasSelections)(tab));
    const clearProducts = $8fa95e6732429854$export$7046da6c329e2110();
    return (next)=>{
        if (next === tab) return;
        setProductTabSelectionWarningShown(hasSelections);
        clearProducts();
        setTab(next);
    };
};
const $8fa95e6732429854$export$8212d82dd5be3dd = ()=>{
    const { setProducts: setProducts } = (0, $9lJTH.useUbpContext)();
    return (0, $1oC0p.useCallback)((productKey)=>{
        setProducts((prev)=>prev.filter((product)=>product.productKey !== productKey));
    }, [
        setProducts
    ]);
};
const $8fa95e6732429854$export$def94a993d8009ff = ()=>{
    const { setProducts: setProducts, orgUserCount: orgUserCount } = (0, $9lJTH.useUbpContext)();
    return (0, $1oC0p.useCallback)((key, selected)=>{
        const category = (0, $cGx7y.getProductPricingConfig)(key).category;
        setProducts((prev)=>{
            if (!selected) return prev.filter((p)=>p.productKey !== key);
            const sameCategory = prev.filter((p)=>p.productKey !== key && (0, $cGx7y.getProductPricingConfig)(p.productKey).category === category);
            const base = (0, $9lJTH.buildDefaultProduct)(key);
            const seeded = {
                ...base,
                inputs: {
                    ...base.inputs,
                    unitCount: orgUserCount ?? base.inputs.unitCount
                }
            };
            return [
                ...sameCategory,
                seeded
            ];
        });
    }, [
        setProducts,
        orgUserCount
    ]);
};
const $8fa95e6732429854$var$useUpdateProductInputs = ()=>{
    const { setProducts: setProducts } = (0, $9lJTH.useUbpContext)();
    return (0, $1oC0p.useCallback)((productKey, patch)=>{
        setProducts((prev)=>prev.map((product)=>product.productKey === productKey ? {
                    ...product,
                    inputs: {
                        ...product.inputs,
                        ...patch
                    }
                } : product));
    }, [
        setProducts
    ]);
};

});
parcelRegister("cGx7y", function(module, exports) {
$parcel$export(module.exports, "productPricingConfigs", function () { return $97ddc95827d4610b$export$93f5d26437fc4220; });
$parcel$export(module.exports, "productPricingConfigKeys", function () { return $97ddc95827d4610b$export$ece495eb5e96bca4; });
$parcel$export(module.exports, "getProductPricingConfig", function () { return $97ddc95827d4610b$export$4521892356e3707c; });

var $29JVp = parcelRequire("29JVp");

var $j1ORI = parcelRequire("j1ORI");

var $lc7EO = parcelRequire("lc7EO");

var $gcAZd = parcelRequire("gcAZd");

var $4utnL = parcelRequire("4utnL");

var $2umYh = parcelRequire("2umYh");

var $fEBe5 = parcelRequire("fEBe5");

var $baQhc = parcelRequire("baQhc");

var $YmHME = parcelRequire("YmHME");
// Preference order for the default edition: prefer a paid mid-tier, else fall
// back to whatever the product actually sells. Some products sell only one
// edition, so the final fallback is the first registered edition rather than a
// fixed "free".
const $97ddc95827d4610b$var$EDITION_PREFERENCE = [
    'standard',
    'free',
    'premium',
    'enterprise'
];
const $97ddc95827d4610b$export$93f5d26437fc4220 = {
    jira: $97ddc95827d4610b$var$defineProduct({
        productKey: 'jira',
        category: 'app',
        config: {
            planLimitConfigs: $j1ORI.jiraPlanLimitConfigs,
            billingCycleConfig: $j1ORI.jiraBillingCycleConfig,
            unitMinEnterprise: $j1ORI.JIRA_MIN_ENTERPRISE_USER_COUNT
        },
        editionToSku: $j1ORI.jiraOfferingSkus,
        offeringSkus: $j1ORI.jiraOfferingSkusArray,
        defaultUnitCount: $j1ORI.JIRA_DEFAULT_UNIT_COUNT,
        defaultBillingCycle: $j1ORI.JIRA_DEFAULT_BILLING_CYCLE
    }),
    confluence: $97ddc95827d4610b$var$defineProduct({
        productKey: 'confluence',
        category: 'app',
        config: {
            planLimitConfigs: $29JVp.confluencePlanLimitConfigs,
            billingCycleConfig: $29JVp.confluenceBillingCycleConfig,
            unitMinEnterprise: $29JVp.CONFLUENCE_MIN_ENTERPRISE_USER_COUNT
        },
        editionToSku: $29JVp.confluenceOfferingSkus,
        offeringSkus: $29JVp.confluenceOfferingSkusArray,
        defaultUnitCount: $29JVp.CONFLUENCE_DEFAULT_UNIT_COUNT,
        defaultBillingCycle: $29JVp.CONFLUENCE_DEFAULT_BILLING_CYCLE
    }),
    jsm: $97ddc95827d4610b$var$defineProduct({
        productKey: 'jsm',
        category: 'app',
        config: {
            planLimitConfigs: $gcAZd.jsmPlanLimitConfigs,
            billingCycleConfig: $gcAZd.jsmBillingCycleConfig,
            unitMinEnterprise: $gcAZd.JSM_MIN_ENTERPRISE_USER_COUNT
        },
        editionToSku: $gcAZd.jsmOfferingSkus,
        offeringSkus: $gcAZd.jsmOfferingSkusArray,
        defaultUnitCount: $gcAZd.JSM_DEFAULT_UNIT_COUNT,
        defaultBillingCycle: $gcAZd.JSM_DEFAULT_BILLING_CYCLE
    }),
    jpd: $97ddc95827d4610b$var$defineProduct({
        productKey: 'jpd',
        category: 'app',
        config: {
            // jpd's plan-limit + sku exports are FF-gated functions, not the
            // static arrays every other config uses — call them here.
            planLimitConfigs: $lc7EO.jpdPlanLimitConfigs(),
            billingCycleConfig: $lc7EO.jpdBillingCycleConfig,
            unitMinEnterprise: $lc7EO.JPD_MIN_ENTERPRISE_USER_COUNT
        },
        editionToSku: $lc7EO.jpdOfferingSkus,
        offeringSkus: $lc7EO.jpdOfferingSkusArray(),
        defaultUnitCount: $lc7EO.JPD_DEFAULT_UNIT_COUNT,
        defaultBillingCycle: $lc7EO.JPD_DEFAULT_BILLING_CYCLE
    }),
    loom: $97ddc95827d4610b$var$defineProduct({
        productKey: 'loom',
        category: 'app',
        config: {
            planLimitConfigs: $4utnL.loomPlanLimitConfigs,
            billingCycleConfig: $4utnL.loomBillingCycleConfig,
            unitMinEnterprise: $4utnL.LOOM_MIN_ENTERPRISE_USER_COUNT
        },
        editionToSku: $4utnL.loomOfferingSkus,
        offeringSkus: $4utnL.loomOfferingSkusArray,
        defaultUnitCount: $4utnL.LOOM_DEFAULT_UNIT_COUNT,
        defaultBillingCycle: $4utnL.LOOM_DEFAULT_BILLING_CYCLE
    }),
    talent: $97ddc95827d4610b$var$defineProduct({
        productKey: 'talent',
        category: 'app',
        config: {
            planLimitConfigs: $baQhc.talentPlanLimitConfigs,
            billingCycleConfig: $baQhc.talentBillingCycleConfig,
            unitMinEnterprise: $baQhc.TALENT_MIN_ENTERPRISE_USER_COUNT
        },
        editionToSku: $baQhc.talentOfferingSkus,
        offeringSkus: $baQhc.talentOfferingSkusArray,
        defaultUnitCount: $baQhc.TALENT_DEFAULT_UNIT_COUNT,
        defaultBillingCycle: $baQhc.TALENT_DEFAULT_BILLING_CYCLE
    }),
    teamworkCollection: $97ddc95827d4610b$var$defineProduct({
        productKey: 'teamworkCollection',
        category: 'collection',
        config: {
            planLimitConfigs: $YmHME.teamworkCollectionPlanLimitConfigs,
            billingCycleConfig: $YmHME.teamworkCollectionBillingCycleConfig,
            unitMinEnterprise: $YmHME.TEAMWORK_COLLECTION_MIN_ENTERPRISE_USER_COUNT
        },
        editionToSku: $YmHME.teamworkCollectionOfferingSkus,
        offeringSkus: $YmHME.teamworkCollectionOfferingSkusArray,
        defaultUnitCount: $YmHME.TEAMWORK_COLLECTION_DEFAULT_UNIT_COUNT,
        defaultBillingCycle: $YmHME.TEAMWORK_COLLECTION_DEFAULT_BILLING_CYCLE
    }),
    serviceCollection: $97ddc95827d4610b$var$defineProduct({
        productKey: 'serviceCollection',
        category: 'collection',
        config: {
            planLimitConfigs: $fEBe5.serviceCollectionPlanLimitConfigs,
            billingCycleConfig: $fEBe5.serviceCollectionBillingCycleConfig,
            unitMinEnterprise: $fEBe5.SERVICE_COLLECTION_MIN_ENTERPRISE_USER_COUNT
        },
        editionToSku: $fEBe5.serviceCollectionOfferingSkus,
        offeringSkus: $fEBe5.serviceCollectionOfferingSkusArray,
        defaultUnitCount: $fEBe5.SERVICE_COLLECTION_DEFAULT_UNIT_COUNT,
        defaultBillingCycle: $fEBe5.SERVICE_COLLECTION_DEFAULT_BILLING_CYCLE
    }),
    productCollection: $97ddc95827d4610b$var$defineProduct({
        productKey: 'productCollection',
        category: 'collection',
        config: {
            planLimitConfigs: $2umYh.productCollectionPlanLimitConfigs,
            billingCycleConfig: $2umYh.productCollectionBillingCycleConfig,
            unitMinEnterprise: $2umYh.PRODUCT_COLLECTION_MIN_ENTERPRISE_USER_COUNT
        },
        editionToSku: $2umYh.productCollectionOfferingSkus,
        offeringSkus: $2umYh.productCollectionOfferingSkusArray,
        defaultUnitCount: $2umYh.PRODUCT_COLLECTION_DEFAULT_UNIT_COUNT,
        defaultBillingCycle: $2umYh.PRODUCT_COLLECTION_DEFAULT_BILLING_CYCLE
    })
};
const $97ddc95827d4610b$export$ece495eb5e96bca4 = Object.keys($97ddc95827d4610b$export$93f5d26437fc4220);
const $97ddc95827d4610b$export$4521892356e3707c = (productKey)=>{
    const def = $97ddc95827d4610b$export$93f5d26437fc4220[productKey];
    if (!def) throw new Error(`No UBP product pricing config registered for "${productKey}"`);
    return def;
};
function $97ddc95827d4610b$var$defineProduct(args) {
    const defaultEdition = $97ddc95827d4610b$var$EDITION_PREFERENCE.find((edition)=>args.editionToSku[edition]) ?? Object.keys(args.editionToSku)[0];
    return {
        productKey: args.productKey,
        category: args.category,
        planLimitConfigs: args.config.planLimitConfigs,
        billingCycleConfig: args.config.billingCycleConfig,
        unitMinEnterprise: args.config.unitMinEnterprise,
        editionToSku: args.editionToSku,
        offeringSkus: args.offeringSkus,
        defaults: {
            edition: defaultEdition,
            unitCount: args.defaultUnitCount,
            billingCycle: args.defaultBillingCycle
        }
    };
}

});
parcelRegister("2umYh", function(module, exports) {
$parcel$export(module.exports, "PRODUCT_COLLECTION_DEFAULT_BILLING_CYCLE", function () { return $254d3dd254634a56$export$3416b2cbfaeda059; });
$parcel$export(module.exports, "PRODUCT_COLLECTION_DEFAULT_UNIT_COUNT", function () { return $254d3dd254634a56$export$2ccfc795c44a39d4; });
$parcel$export(module.exports, "PRODUCT_COLLECTION_MIN_ENTERPRISE_USER_COUNT", function () { return $254d3dd254634a56$export$af088ce9d0322849; });
$parcel$export(module.exports, "productCollectionOfferingSkus", function () { return $254d3dd254634a56$export$2f6eaa7175cc0ad; });
$parcel$export(module.exports, "productCollectionOfferingSkusArray", function () { return $254d3dd254634a56$export$67107ef81440ea6d; });
$parcel$export(module.exports, "productCollectionPlanLimitConfigs", function () { return $254d3dd254634a56$export$367ef8827ec58b42; });
$parcel$export(module.exports, "productCollectionBillingCycleConfig", function () { return $254d3dd254634a56$export$7654fb9f0c41edd5; });
// TODO: update configs for product collection
const $254d3dd254634a56$export$3416b2cbfaeda059 = 'MONTHLY';
const $254d3dd254634a56$export$2ccfc795c44a39d4 = 300;
const $254d3dd254634a56$export$af088ce9d0322849 = 801;
const $254d3dd254634a56$export$2f6eaa7175cc0ad = {
    free: 'product-collection-free-sku',
    standard: 'product-collection-standard-sku',
    premium: 'product-collection-premium-sku',
    enterprise: 'product-collection-enterprise-sku'
};
const $254d3dd254634a56$export$67107ef81440ea6d = Object.values($254d3dd254634a56$export$2f6eaa7175cc0ad);
const $254d3dd254634a56$export$367ef8827ec58b42 = [
    {
        planName: 'Free',
        offeringSku: $254d3dd254634a56$export$2f6eaa7175cc0ad.free,
        recommendationLimit: 0,
        signupLimit: 10
    },
    {
        planName: 'Standard',
        offeringSku: $254d3dd254634a56$export$2f6eaa7175cc0ad.standard,
        recommendationLimit: 0,
        signupLimit: 100000
    },
    {
        planName: 'Premium',
        offeringSku: $254d3dd254634a56$export$2f6eaa7175cc0ad.premium,
        recommendationLimit: 0,
        signupLimit: 100000
    },
    {
        planName: 'Enterprise',
        offeringSku: $254d3dd254634a56$export$2f6eaa7175cc0ad.enterprise,
        recommendationLimit: 5000,
        signupLimit: 100000,
        minUnitCount: $254d3dd254634a56$export$af088ce9d0322849
    }
];
const $254d3dd254634a56$export$7654fb9f0c41edd5 = {
    monthly: true,
    annual: true
};

});

parcelRegister("baQhc", function(module, exports) {
$parcel$export(module.exports, "TALENT_DEFAULT_BILLING_CYCLE", function () { return $c377616ac3da85bf$export$4a48798924aaa000; });
$parcel$export(module.exports, "TALENT_DEFAULT_UNIT_COUNT", function () { return $c377616ac3da85bf$export$d0f5675f2b04f5d; });
$parcel$export(module.exports, "TALENT_MIN_ENTERPRISE_USER_COUNT", function () { return $c377616ac3da85bf$export$8078a6397f4363f; });
$parcel$export(module.exports, "talentOfferingSkus", function () { return $c377616ac3da85bf$export$32eab0e8964f6605; });
$parcel$export(module.exports, "talentOfferingSkusArray", function () { return $c377616ac3da85bf$export$29beb5404367143; });
$parcel$export(module.exports, "talentPlanLimitConfigs", function () { return $c377616ac3da85bf$export$f42a277cfbe2fa76; });
$parcel$export(module.exports, "talentBillingCycleConfig", function () { return $c377616ac3da85bf$export$84f8e073fdb6051; });
const $c377616ac3da85bf$export$4a48798924aaa000 = 'MONTHLY';
const $c377616ac3da85bf$export$d0f5675f2b04f5d = 100;
const $c377616ac3da85bf$export$8078a6397f4363f = Infinity;
const $c377616ac3da85bf$export$32eab0e8964f6605 = {
    free: 'talent-free-sku',
    business: 'talent-business-sku',
    businessPlusAi: 'talent-business-ai-sku',
    enterprise: 'talent-enterprise-sku'
};
const $c377616ac3da85bf$export$29beb5404367143 = Object.values($c377616ac3da85bf$export$32eab0e8964f6605);
const $c377616ac3da85bf$export$f42a277cfbe2fa76 = [
    {
        planName: 'Free',
        offeringSku: $c377616ac3da85bf$export$32eab0e8964f6605.free,
        recommendationLimit: Infinity,
        signupLimit: 50000
    },
    {
        planName: 'Business',
        offeringSku: $c377616ac3da85bf$export$32eab0e8964f6605.business,
        recommendationLimit: Infinity,
        signupLimit: 50000
    },
    {
        planName: 'Business + AI',
        offeringSku: $c377616ac3da85bf$export$32eab0e8964f6605.businessPlusAi,
        recommendationLimit: 0,
        signupLimit: 50000
    },
    {
        planName: 'Enterprise',
        offeringSku: $c377616ac3da85bf$export$32eab0e8964f6605.enterprise,
        recommendationLimit: Infinity,
        signupLimit: 50000
    }
];
const $c377616ac3da85bf$export$84f8e073fdb6051 = {
    monthly: true,
    annual: true
};

});


parcelRegister("iqmYR", function(module, exports) {
$parcel$export(module.exports, "resolveBillingCycle", function () { return $ce0500e05adc655d$export$6056e10fba8c9048; });

var $cGx7y = parcelRequire("cGx7y");
const $ce0500e05adc655d$export$6056e10fba8c9048 = (productKey, edition)=>{
    if (edition === 'enterprise') return 'ANNUAL';
    return (0, $cGx7y.getProductPricingConfig)(productKey).billingCycleConfig.monthly ? 'MONTHLY' : 'ANNUAL';
};

});

parcelRegister("73KXs", function(module, exports) {
$parcel$export(module.exports, "STEP_ORDER", function () { return $2c8de9845b52d439$export$fe5882e1cacea70d; });
$parcel$export(module.exports, "EDITION_KEYS", function () { return $2c8de9845b52d439$export$15d2fd08fe349b20; });
const $2c8de9845b52d439$export$fe5882e1cacea70d = [
    'usage',
    'needs',
    'estimate',
    'allowance',
    'summary'
];
const $2c8de9845b52d439$export$15d2fd08fe349b20 = [
    'free',
    'standard',
    'premium',
    'enterprise'
];

});

parcelRegister("9lJTH", function(module, exports) {
$parcel$export(module.exports, "useUbpContext", function () { return $bc97b53d595d3da5$export$dc0276ea3fe966fa; });
$parcel$export(module.exports, "buildDefaultProduct", function () { return $bc97b53d595d3da5$export$32ada19ac063b3af; });
$parcel$export(module.exports, "UbpContextProvider", function () { return $bc97b53d595d3da5$export$17c668f0eddf3669; });
/**
 * The single merged UBP-Q4 context. Holds the wizard flow state (from the
 * flow source) together with the unified product selection + per-product
 * inputs and the CCP pricing data / derived calculation (from the calc
 * source). A product is "selected" iff it is present in `products`.
 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $dkcYJ = parcelRequire("dkcYJ");

var $61WdP = parcelRequire("61WdP");

var $bd927 = parcelRequire("bd927");

var $cGx7y = parcelRequire("cGx7y");

var $iqmYR = parcelRequire("iqmYR");
const $bc97b53d595d3da5$var$UbpContext = /*#__PURE__*/ (0, $1oC0p.createContext)(undefined);
const $bc97b53d595d3da5$export$dc0276ea3fe966fa = ()=>{
    const ctx = (0, $1oC0p.useContext)($bc97b53d595d3da5$var$UbpContext);
    if (!ctx) throw new Error('useUbpContext must be used within a UbpContextProvider');
    return ctx;
};
const $bc97b53d595d3da5$export$32ada19ac063b3af = (productKey)=>{
    const def = (0, $cGx7y.getProductPricingConfig)(productKey);
    return {
        productKey: productKey,
        inputs: {
            edition: def.defaults.edition,
            unitCount: def.defaults.unitCount,
            billingCycle: (0, $iqmYR.resolveBillingCycle)(productKey, def.defaults.edition)
        }
    };
};
const $bc97b53d595d3da5$var$DEFAULT_STEP = 'usage';
const $bc97b53d595d3da5$var$DEFAULT_METER = 'rovoCredits';
const $bc97b53d595d3da5$var$DEFAULT_USAGE_TYPE = 'exploring';
const $bc97b53d595d3da5$var$DEFAULT_USAGE = 0;
const $bc97b53d595d3da5$export$17c668f0eddf3669 = (props)=>{
    const { children: children, initialValues: { step: initialStep = $bc97b53d595d3da5$var$DEFAULT_STEP, meter: initialMeter = $bc97b53d595d3da5$var$DEFAULT_METER, usageType: initialUsageType = $bc97b53d595d3da5$var$DEFAULT_USAGE_TYPE, usage: initialUsage = $bc97b53d595d3da5$var$DEFAULT_USAGE, orgUserCount: initialOrgUserCount, products: initialProducts = [] } = {}, currencyISOCode: currencyISOCode = 'USD', localeISOCode: localeISOCode = 'en-US' } = props;
    const [step, setStep] = (0, $1oC0p.useState)(initialStep);
    const [meter, setMeter] = (0, $1oC0p.useState)(initialMeter);
    const [usageType, setUsageType] = (0, $1oC0p.useState)(initialUsageType);
    const [usage, setUsage] = (0, $1oC0p.useState)(initialUsage);
    const [orgUserCount, setOrgUserCount] = (0, $1oC0p.useState)(initialOrgUserCount);
    const [orgUserCountError, setOrgUserCountError] = (0, $1oC0p.useState)(undefined);
    const [products, setProducts] = (0, $1oC0p.useState)(initialProducts);
    const [productTabSelectionWarningShown, setProductTabSelectionWarningShown] = (0, $1oC0p.useState)(false);
    // Fetch CCP data for the union of every registered product's SKUs once,
    // so selecting/deselecting products never triggers a re-fetch.
    const allSkus = (0, $1oC0p.useMemo)(()=>(0, $bd927.collectAllRegisteredSkus)((0, $cGx7y.productPricingConfigKeys).map((k)=>(0, $cGx7y.productPricingConfigs)[k])), []);
    const { fetchData: fetchData, status: ccpStatus, prices: prices } = (0, $dkcYJ.useCCPPriceFinderData)(allSkus, String((0, $61WdP.PRODUCT_CATALOG_DELIVERY_KEY)), String((0, $61WdP.PRODUCT_CATALOG_SPACE)));
    (0, $1oC0p.useEffect)(()=>{
        fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const ccpPricingData = prices ?? {};
    const calculation = (0, $1oC0p.useMemo)(()=>(0, $bd927.calculateMonthlyPerUnitPrices)({
            products: products,
            ccpPricingData: ccpPricingData,
            currencyISOCode: currencyISOCode,
            localeISOCode: localeISOCode
        }), [
        products,
        ccpPricingData,
        currencyISOCode,
        localeISOCode
    ]);
    const value = {
        step: step,
        meter: meter,
        usageType: usageType,
        usage: usage,
        orgUserCount: orgUserCount,
        products: products,
        setProducts: setProducts,
        productTabSelectionWarningShown: productTabSelectionWarningShown,
        setProductTabSelectionWarningShown: setProductTabSelectionWarningShown,
        ccpPricingData: ccpPricingData,
        ccpStatus: ccpStatus,
        currencyISOCode: currencyISOCode,
        localeISOCode: localeISOCode,
        calculation: calculation,
        setStep: setStep,
        setMeter: setMeter,
        setUsageType: setUsageType,
        setUsage: setUsage,
        setOrgUserCount: setOrgUserCount,
        orgUserCountError: orgUserCountError,
        setOrgUserCountError: setOrgUserCountError
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)($bc97b53d595d3da5$var$UbpContext.Provider, {
        value: value,
        children: children
    });
};

});
parcelRegister("bd927", function(module, exports) {
$parcel$export(module.exports, "calculateMonthlyPerUnitPrices", function () { return $8d7d9aeed8eceb47$export$774ace40e08cc870; });
$parcel$export(module.exports, "collectAllRegisteredSkus", function () { return $8d7d9aeed8eceb47$export$61067bc3afde3a70; });

var $5CQu1 = parcelRequire("5CQu1");

var $8cfMz = parcelRequire("8cfMz");

var $cGx7y = parcelRequire("cGx7y");
const $8d7d9aeed8eceb47$var$MONTHS_PER_YEAR = 12;
function $8d7d9aeed8eceb47$export$774ace40e08cc870(args) {
    const { products: products, ccpPricingData: ccpPricingData, currencyISOCode: currencyISOCode, localeISOCode: localeISOCode } = args;
    const byProductKey = {};
    for (const product of products){
        const def = (0, $cGx7y.getProductPricingConfig)(product.productKey);
        const { edition: edition, unitCount: unitCount, billingCycle: billingCycle } = product.inputs;
        const selectedSku = def.editionToSku[edition];
        const calcInputs = (0, $8cfMz.getProductCalculationInputs)(def.planLimitConfigs, def.unitMinEnterprise, unitCount, billingCycle);
        const avgPerUnitPrice = (0, $5CQu1.calculateProductPricing)(ccpPricingData, calcInputs, currencyISOCode, localeISOCode).find((r)=>r.offeringSku === selectedSku)?.avgPerUnitPrice;
        if (avgPerUnitPrice === undefined) continue;
        // The calculator's per-unit figure is annual for ANNUAL billing.
        byProductKey[product.productKey] = billingCycle === 'ANNUAL' ? avgPerUnitPrice / $8d7d9aeed8eceb47$var$MONTHS_PER_YEAR : avgPerUnitPrice;
    }
    return {
        byProductKey: byProductKey
    };
}
function $8d7d9aeed8eceb47$export$61067bc3afde3a70(pricingConfigs) {
    const set = new Set();
    for (const cfg of pricingConfigs)for (const sku of cfg.offeringSkus)set.add(sku);
    return [
        ...set
    ];
}

});


parcelRegister("hSUNh", function(module, exports) {
$parcel$export(module.exports, "selectStep", function () { return $9558c935db5ea40c$export$7938144936e8342b; });
$parcel$export(module.exports, "selectMeter", function () { return $9558c935db5ea40c$export$b73dc07af4ca8585; });
$parcel$export(module.exports, "selectUsageType", function () { return $9558c935db5ea40c$export$dbd8d08dc10418e1; });
$parcel$export(module.exports, "selectUsage", function () { return $9558c935db5ea40c$export$a2d8c0eb2185aa32; });
$parcel$export(module.exports, "selectOrgUserCount", function () { return $9558c935db5ea40c$export$e13a46e9e42e8a29; });
$parcel$export(module.exports, "selectOrgUserCountError", function () { return $9558c935db5ea40c$export$f92f8202ac00197a; });
$parcel$export(module.exports, "selectCanAdvanceUsageStep", function () { return $9558c935db5ea40c$export$6df6c3f509d1549d; });
$parcel$export(module.exports, "selectCanAdvanceAllowanceStep", function () { return $9558c935db5ea40c$export$b7b4f1e88739f7ba; });
$parcel$export(module.exports, "selectStepIndex", function () { return $9558c935db5ea40c$export$c35690e08b926207; });
$parcel$export(module.exports, "selectIncludedAllowance", function () { return $9558c935db5ea40c$export$6fadf034e788ba2; });
$parcel$export(module.exports, "selectEstimatedUsageRange", function () { return $9558c935db5ea40c$export$aa6e21e0c5ae49c4; });
$parcel$export(module.exports, "isCcpDataPending", function () { return $9558c935db5ea40c$export$4755891f136cec04; });
$parcel$export(module.exports, "selectIsProductSelected", function () { return $9558c935db5ea40c$export$de52de5f9450c9fe; });
$parcel$export(module.exports, "selectProductTabSelectionWarningShown", function () { return $9558c935db5ea40c$export$c367dfb5ad56f8d1; });
$parcel$export(module.exports, "selectCategoryHasSelections", function () { return $9558c935db5ea40c$export$ee40fe8bb6549e45; });
$parcel$export(module.exports, "selectInitialProductsTab", function () { return $9558c935db5ea40c$export$d68a0d389d453331; });
$parcel$export(module.exports, "selectShareableQuery", function () { return $9558c935db5ea40c$export$45bf5c0a18de967d; });
/**
 * Pure selectors over the merged UBP-Q4 context. Three groups:
 *   A. wizard flow (ported from the flow source)
 *   B. per-product reads (ported from the calc source)
 *   C. selection selectors that bridge flow ↔ products
 *
 * Selectors return only data (keys, numbers, enums) — never display strings.
 * Labels and number/currency formatting live in components/strings.ts.
 * Composition is done by calling other selectors with the same `ctx`.
 */ 
var $i8jvR = parcelRequire("i8jvR");

var $cGx7y = parcelRequire("cGx7y");

var $73KXs = parcelRequire("73KXs");

var $5eLaZ = parcelRequire("5eLaZ");
const $9558c935db5ea40c$export$7938144936e8342b = (ctx)=>ctx.step;
const $9558c935db5ea40c$export$b73dc07af4ca8585 = (ctx)=>ctx.meter;
const $9558c935db5ea40c$export$dbd8d08dc10418e1 = (ctx)=>ctx.usageType;
const $9558c935db5ea40c$export$a2d8c0eb2185aa32 = (ctx)=>ctx.usage;
const $9558c935db5ea40c$export$e13a46e9e42e8a29 = (ctx)=>ctx.orgUserCount;
const $9558c935db5ea40c$export$f92f8202ac00197a = (ctx)=>ctx.orgUserCountError;
const $9558c935db5ea40c$export$6df6c3f509d1549d = (ctx)=>(0, $5eLaZ.validateOrgUserCount)($9558c935db5ea40c$export$e13a46e9e42e8a29(ctx)) === undefined;
const $9558c935db5ea40c$export$b7b4f1e88739f7ba = (ctx)=>$9558c935db5ea40c$export$a3c41b69185a85ac(ctx).length > 0;
const $9558c935db5ea40c$export$c35690e08b926207 = (ctx)=>(0, $73KXs.STEP_ORDER).indexOf($9558c935db5ea40c$export$7938144936e8342b(ctx));
const $9558c935db5ea40c$export$6fadf034e788ba2 = (ctx)=>(0, $i8jvR.calculateIncludedAllowance)({
        products: ctx.products,
        meter: ctx.meter
    });
const $9558c935db5ea40c$export$aa6e21e0c5ae49c4 = ()=>{
    // TODO(GWP-12277): derive from orgUserCount + meter + usageType.
    return {
        low: 145000,
        high: 160000
    };
};
const $9558c935db5ea40c$export$ce9cf0f15e42cff9 = (ctx, productKey)=>{
    const product = ctx.products.find((p)=>p.productKey === productKey);
    if (!product) throw new Error(`No product found for productKey="${productKey}"`);
    return product;
};
const $9558c935db5ea40c$export$53e066a63a960439 = (ctx, productKey)=>$9558c935db5ea40c$export$ce9cf0f15e42cff9(ctx, productKey).inputs.edition;
const $9558c935db5ea40c$export$34c177475ae85bf6 = (ctx, productKey)=>$9558c935db5ea40c$export$ce9cf0f15e42cff9(ctx, productKey).inputs.unitCount;
const $9558c935db5ea40c$export$21639746dd26fa06 = (ctx, productKey)=>$9558c935db5ea40c$export$ce9cf0f15e42cff9(ctx, productKey).inputs.billingCycle;
const $9558c935db5ea40c$export$9fb2997fa3909ba7 = (ctx, productKey)=>ctx.calculation.byProductKey[productKey];
const $9558c935db5ea40c$export$4755891f136cec04 = (ctx)=>ctx.ccpStatus === 'idle' || ctx.ccpStatus === 'fetching';
const $9558c935db5ea40c$export$5052d5e5b6a90fdc = (ctx)=>ctx.currencyISOCode;
const $9558c935db5ea40c$export$3d36f1c8af14c3fb = (ctx)=>ctx.localeISOCode;
const $9558c935db5ea40c$export$a3c41b69185a85ac = (ctx)=>ctx.products;
const $9558c935db5ea40c$export$de52de5f9450c9fe = (key)=>(ctx)=>ctx.products.some((p)=>p.productKey === key);
const $9558c935db5ea40c$export$c367dfb5ad56f8d1 = (ctx)=>ctx.productTabSelectionWarningShown;
const $9558c935db5ea40c$export$ee40fe8bb6549e45 = (category)=>(ctx)=>ctx.products.some((p)=>(0, $cGx7y.getProductPricingConfig)(p.productKey).category === category);
const $9558c935db5ea40c$export$33954d9a4543aed8 = (ctx)=>{
    const first = ctx.products[0];
    return first ? (0, $cGx7y.getProductPricingConfig)(first.productKey).category : null;
};
const $9558c935db5ea40c$export$d68a0d389d453331 = (ctx)=>$9558c935db5ea40c$export$33954d9a4543aed8(ctx) ?? 'app';
const $9558c935db5ea40c$export$45bf5c0a18de967d = (ctx)=>{
    const products = $9558c935db5ea40c$export$a3c41b69185a85ac(ctx);
    const query = {
        step: $9558c935db5ea40c$export$7938144936e8342b(ctx),
        meter: $9558c935db5ea40c$export$b73dc07af4ca8585(ctx),
        usageType: $9558c935db5ea40c$export$dbd8d08dc10418e1(ctx),
        usage: $9558c935db5ea40c$export$a2d8c0eb2185aa32(ctx),
        orgUserCount: $9558c935db5ea40c$export$e13a46e9e42e8a29(ctx),
        products: products.map((p)=>p.productKey)
    };
    for (const p of products)query[`product.${p.productKey}`] = {
        unitCount: p.inputs.unitCount,
        edition: p.inputs.edition,
        billingCycle: p.inputs.billingCycle
    };
    return query;
};

});
parcelRegister("i8jvR", function(module, exports) {
$parcel$export(module.exports, "calculateIncludedAllowance", function () { return $5e50a12920d99a42$export$5adb36b887bdb2cc; });

var $gEJcR = parcelRequire("gEJcR");
// (product, edition) -> entitlement data file SKU. Only combinations that have a
// data file are listed; anything omitted resolves to 0.
const $5e50a12920d99a42$var$DATA_SKU = {
    jira: {
        free: 'jira-software-free',
        standard: 'jira-software-standard',
        premium: 'jira-software-premium',
        enterprise: 'jira-software-enterprise-sku'
    },
    confluence: {
        free: 'confluence-free',
        standard: 'confluence-standard',
        premium: 'confluence-premium',
        enterprise: 'confluence-enterprise-sku'
    },
    jsm: {
        free: 'jira-servicedesk-free',
        standard: 'jira-servicedesk-standard',
        premium: 'jira-servicedesk-premium',
        enterprise: 'jira-servicedesk-enterprise-sku'
    },
    jpd: {
        free: 'jira-servicedesk-free',
        standard: 'jira-product-discovery-standard',
        premium: 'jira-product-discovery-premium-sku',
        enterprise: 'jira-product-discovery-enterprise'
    },
    loom: {
        free: 'loom-free',
        standard: 'loom-standard',
        premium: 'loom-premium-sku',
        enterprise: 'loom-enterprise'
    },
    talent: {
        free: 'talent-free',
        standard: 'talent-standard',
        premium: 'talent-premium-sku',
        enterprise: 'talent-enterprise'
    },
    teamworkCollection: {
        free: 'teamwork-collection-free-sku',
        standard: 'teamwork-collection-standard-sku',
        premium: 'teamwork-collection-premium-sku',
        enterprise: 'teamwork-collection-enterprise-sku'
    },
    serviceCollection: {
        enterprise: 'service-collection-enterprise'
    },
    productCollection: {
        enterprise: 'product-collection-enterprise-sku'
    }
};
// Meter -> entitlement usageKey.
const $5e50a12920d99a42$var$METER_USAGE_KEY = {
    rovoCredits: 'ai-credit',
    automations: 'automation-credits',
    csResolutions: 'cs-resolution',
    // no entitlement data yet
    assetsObjects: 'assets-objects'
};
function $5e50a12920d99a42$export$5adb36b887bdb2cc(args) {
    const { products: products, meter: meter } = args;
    let sum = 0;
    for (const product of products){
        const sku = $5e50a12920d99a42$var$DATA_SKU[product.productKey][product.inputs.edition];
        if (!sku) continue;
        const perUnit = (0, $gEJcR.getAllowance)({
            sku: sku,
            meter: $5e50a12920d99a42$var$METER_USAGE_KEY[meter],
            billingCycle: product.inputs.billingCycle
        });
        if (!perUnit) continue;
        sum += perUnit * product.inputs.unitCount;
    }
    return Math.round(sum);
}

});
parcelRegister("gEJcR", function(module, exports) {
$parcel$export(module.exports, "getAllowance", function () { return $466032012911a17a$export$64c885348b2f1759; });

var $hLkPQ = parcelRequire("hLkPQ");

var $6gNGp = parcelRequire("6gNGp");

var $9k7dI = parcelRequire("9k7dI");

var $lM1xu = parcelRequire("lM1xu");

var $4CZG9 = parcelRequire("4CZG9");

var $2JqOL = parcelRequire("2JqOL");

var $cWskG = parcelRequire("cWskG");

var $7MGiZ = parcelRequire("7MGiZ");

var $dThEb = parcelRequire("dThEb");

var $8Er1n = parcelRequire("8Er1n");

var $6op9h = parcelRequire("6op9h");

var $2FsPv = parcelRequire("2FsPv");

var $4j3E0 = parcelRequire("4j3E0");

var $9HRSO = parcelRequire("9HRSO");

var $c9mas = parcelRequire("c9mas");

var $cI23f = parcelRequire("cI23f");

var $4smqI = parcelRequire("4smqI");

var $e5ZMN = parcelRequire("e5ZMN");

var $4Y3Fa = parcelRequire("4Y3Fa");

var $d6TPP = parcelRequire("d6TPP");
const $466032012911a17a$export$64c885348b2f1759 = ({ sku: sku, meter: meter, billingCycle: billingCycle })=>$466032012911a17a$var$allowanceIndex[sku]?.[meter]?.[billingCycle];
// Keyed by SKU (`<product>-<edition>`), which is how the entitlement files are named.
const $466032012911a17a$var$templatesBySku = {
    'confluence-enterprise-sku': (0, (/*@__PURE__*/$parcel$interopDefault($hLkPQ))),
    'confluence-free': (0, (/*@__PURE__*/$parcel$interopDefault($6gNGp))),
    'confluence-premium': (0, (/*@__PURE__*/$parcel$interopDefault($9k7dI))),
    'confluence-standard': (0, (/*@__PURE__*/$parcel$interopDefault($lM1xu))),
    'jira-product-discovery-enterprise': (0, (/*@__PURE__*/$parcel$interopDefault($4CZG9))),
    'jira-product-discovery-premium-sku': (0, (/*@__PURE__*/$parcel$interopDefault($2JqOL))),
    'jira-product-discovery-standard': (0, (/*@__PURE__*/$parcel$interopDefault($cWskG))),
    'jira-servicedesk-enterprise-sku': (0, (/*@__PURE__*/$parcel$interopDefault($7MGiZ))),
    'jira-servicedesk-free': (0, (/*@__PURE__*/$parcel$interopDefault($dThEb))),
    'jira-servicedesk-premium': (0, (/*@__PURE__*/$parcel$interopDefault($8Er1n))),
    'jira-servicedesk-standard': (0, (/*@__PURE__*/$parcel$interopDefault($6op9h))),
    'jira-software-enterprise-sku': (0, (/*@__PURE__*/$parcel$interopDefault($2FsPv))),
    'jira-software-free': (0, (/*@__PURE__*/$parcel$interopDefault($4j3E0))),
    'jira-software-premium': (0, (/*@__PURE__*/$parcel$interopDefault($9HRSO))),
    'jira-software-standard': (0, (/*@__PURE__*/$parcel$interopDefault($c9mas))),
    'service-collection-enterprise': (0, (/*@__PURE__*/$parcel$interopDefault($cI23f))),
    'teamwork-collection-enterprise-sku': (0, (/*@__PURE__*/$parcel$interopDefault($4smqI))),
    'teamwork-collection-free-sku': (0, (/*@__PURE__*/$parcel$interopDefault($e5ZMN))),
    'teamwork-collection-premium-sku': (0, (/*@__PURE__*/$parcel$interopDefault($4Y3Fa))),
    'teamwork-collection-standard-sku': (0, (/*@__PURE__*/$parcel$interopDefault($d6TPP)))
};
// sku -> meter (usageKey) -> billing cycle -> allowance amount.
const $466032012911a17a$var$buildIndex = ()=>{
    const index = {};
    for (const [sku, template] of Object.entries($466032012911a17a$var$templatesBySku)){
        const meterIndex = {};
        for (const feature of template.features)for (const allowance of feature.value?.allowances ?? []){
            const { usageKey: usageKey, cycles: cycles } = allowance.config;
            const cycleIndex = meterIndex[usageKey] ??= {};
            for (const cycle of cycles)cycleIndex[cycle.cycle] = cycle.amount;
        }
        index[sku] = meterIndex;
    }
    return index;
};
const $466032012911a17a$var$allowanceIndex = $466032012911a17a$var$buildIndex();

});
parcelRegister("hLkPQ", function(module, exports) {
module.exports = JSON.parse("{\"description\":\"Confluence Enterprise Template\",\"features\":[{\"featureId\":\"provided-allowances\",\"domain\":\"BILLING\",\"value\":{\"allowances\":[{\"reference\":\"allowance_indexed-document\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"indexed-document\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":625,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":625,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}},{\"reference\":\"allowance_ai-credit\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"ai-credit\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":150,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":150,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}},{\"reference\":\"allowance_automation-credits\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"automation-credits\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":500,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":500,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}}]}}]}");

});

parcelRegister("6gNGp", function(module, exports) {
module.exports = JSON.parse("{\"description\":\"Entitlement Template for Confluence (Cloud) Free\",\"features\":[]}");

});

parcelRegister("9k7dI", function(module, exports) {
module.exports = JSON.parse("{\"description\":\"Entitlement Template for Confluence (Cloud) Premium\",\"features\":[{\"featureId\":\"provided-allowances\",\"domain\":\"BILLING\",\"value\":{\"allowances\":[{\"reference\":\"allowance_indexed-document\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"indexed-document\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":250,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":250,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}},{\"reference\":\"allowance_ai-credit\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"ai-credit\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":70,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":70,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}},{\"reference\":\"allowance_automation-credits\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"automation-credits\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":250,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":250,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}}]}}]}");

});

parcelRegister("lM1xu", function(module, exports) {
module.exports = JSON.parse("{\"description\":\"Entitlement Template for Confluence (Cloud) Standard\",\"features\":[{\"featureId\":\"provided-allowances\",\"domain\":\"BILLING\",\"value\":{\"allowances\":[{\"reference\":\"allowance_indexed-document\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"indexed-document\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":100,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":100,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}},{\"reference\":\"allowance_ai-credit\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"ai-credit\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":25,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":25,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}},{\"reference\":\"allowance_automation-credits\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"automation-credits\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":100,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":100,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}}]}}]}");

});

parcelRegister("4CZG9", function(module, exports) {
module.exports = JSON.parse("{\"description\":\"Entitlement template for product a6f908c8-709c-45f4-9e2d-eca25b93b94a\",\"features\":[]}");

});

parcelRegister("2JqOL", function(module, exports) {
module.exports = JSON.parse("{\"description\":\"Entitlement template for product a6f908c8-709c-45f4-9e2d-eca25b93b94a\",\"features\":[{\"featureId\":\"provided-allowances\",\"domain\":\"BILLING\",\"value\":{\"allowances\":[{\"reference\":\"allowance_automation-credits\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"automation-credits\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":500,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":500,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}}]}}]}");

});

parcelRegister("cWskG", function(module, exports) {
module.exports = JSON.parse("{\"description\":\"Entitlement Template for Jira Product Discovery Standard\",\"features\":[{\"featureId\":\"provided-allowances\",\"domain\":\"BILLING\",\"value\":{\"allowances\":[{\"reference\":\"allowance_automation-credits\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"automation-credits\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":300,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":300,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}}]}}]}");

});

parcelRegister("7MGiZ", function(module, exports) {
module.exports = JSON.parse("{\"description\":\"Jira Service Management Enterprise Template\",\"features\":[{\"featureId\":\"provided-allowances\",\"domain\":\"BILLING\",\"value\":{\"allowances\":[{\"reference\":\"allowance_indexed-document\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"indexed-document\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":625,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"agent\"}},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":625,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"agent\"}}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}},{\"reference\":\"allowance_ai-credit\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"ai-credit\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":150,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"agent\"}},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":150,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"agent\"}}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}},{\"reference\":\"allowance_assets-objects\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"assets-objects\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":500000},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":500000}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}},{\"reference\":\"allowance_automation-credits\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"automation-credits\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":7500,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"agent\"}},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":7500,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"agent\"}}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}}]}}]}");

});

parcelRegister("dThEb", function(module, exports) {
module.exports = JSON.parse("{\"description\":\"Entitlement Template for Jira Service Management (Cloud) Free\",\"features\":[]}");

});

parcelRegister("8Er1n", function(module, exports) {
module.exports = JSON.parse("{\"description\":\"Entitlement Templates for Jira Service Management Premium\",\"features\":[{\"featureId\":\"provided-allowances\",\"domain\":\"BILLING\",\"value\":{\"allowances\":[{\"reference\":\"allowance_indexed-document\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"indexed-document\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":250,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"agent\"}},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":250,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"agent\"}}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}},{\"reference\":\"allowance_ai-credit\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"ai-credit\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":70,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"agent\"}},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":70,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"agent\"}}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}},{\"reference\":\"allowance_assets-objects\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"assets-objects\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":50000},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":50000}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}},{\"reference\":\"allowance_automation-credits\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"automation-credits\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":5000,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"agent\"}},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":5000,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"agent\"}}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}}]}}]}");

});

parcelRegister("6op9h", function(module, exports) {
module.exports = JSON.parse("{\"description\":\"Entitlement Templates for Jira Service Management Standard\",\"features\":[{\"featureId\":\"provided-allowances\",\"domain\":\"BILLING\",\"value\":{\"allowances\":[{\"reference\":\"allowance_indexed-document\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"indexed-document\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":100,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"agent\"}},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":100,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"agent\"}}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}},{\"reference\":\"allowance_ai-credit\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"ai-credit\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":25,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"agent\"}},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":25,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"agent\"}}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}},{\"reference\":\"allowance_assets-objects\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"assets-objects\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":5000},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":5000}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}},{\"reference\":\"allowance_automation-credits\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"automation-credits\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":2500,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"agent\"}},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":2500,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"agent\"}}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}}]}}]}");

});

parcelRegister("2FsPv", function(module, exports) {
module.exports = JSON.parse("{\"description\":\"Jira Enterprise Template\",\"features\":[{\"featureId\":\"provided-allowances\",\"domain\":\"BILLING\",\"value\":{\"allowances\":[{\"reference\":\"allowance_indexed-document\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"indexed-document\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":625,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":625,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}},{\"reference\":\"allowance_ai-credit\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"ai-credit\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":150,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":150,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}},{\"reference\":\"allowance_assets-objects\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"assets-objects\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":1000},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":1000}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}},{\"reference\":\"allowance_automation-credits\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"automation-credits\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":1000,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":1000,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}}]}}]}");

});

parcelRegister("4j3E0", function(module, exports) {
module.exports = JSON.parse("{\"description\":\"Entitlement Template for Jira Software (Cloud) Free\",\"features\":[]}");

});

parcelRegister("9HRSO", function(module, exports) {
module.exports = JSON.parse("{\"description\":\"Entitlement Template for Jira Software (Cloud) Premium\",\"features\":[{\"featureId\":\"provided-allowances\",\"domain\":\"BILLING\",\"value\":{\"allowances\":[{\"reference\":\"allowance_indexed-document\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"indexed-document\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":250,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":250,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}},{\"reference\":\"allowance_ai-credit\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"ai-credit\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":70,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":70,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}},{\"reference\":\"allowance_assets-objects\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"assets-objects\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":1000},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":1000}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}},{\"reference\":\"allowance_automation-credits\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"automation-credits\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":750,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":750,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}}]}}]}");

});

parcelRegister("c9mas", function(module, exports) {
module.exports = JSON.parse("{\"description\":\"Entitlement Template for Jira Software (Cloud) Standard\",\"features\":[{\"featureId\":\"provided-allowances\",\"domain\":\"BILLING\",\"value\":{\"allowances\":[{\"reference\":\"allowance_indexed-document\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"indexed-document\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":100,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":100,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}},{\"reference\":\"allowance_ai-credit\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"ai-credit\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":25,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":25,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}},{\"reference\":\"allowance_assets-objects\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"assets-objects\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":1000},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":1000}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}},{\"reference\":\"allowance_automation-credits\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"automation-credits\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":400,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":400,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}}]}}]}");

});

parcelRegister("cI23f", function(module, exports) {
module.exports = JSON.parse("{\"description\":\"Service Collection Entitlement template\",\"features\":[{\"featureId\":\"provided-allowances\",\"domain\":\"BILLING\",\"value\":{\"allowances\":[{\"reference\":\"allowance_indexed-document\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"indexed-document\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":625,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"agent\"}},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":625,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"agent\"}}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}},{\"reference\":\"allowance_ai-credit\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"ai-credit\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":150,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"agent\"}},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":150,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"agent\"}}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}},{\"reference\":\"allowance_assets-objects\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"assets-objects\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":500000},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":500000}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}},{\"reference\":\"allowance_automation-credits\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"automation-credits\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":7500,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"agent\"}},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":7500,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"agent\"}}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}}]}}]}");

});

parcelRegister("4smqI", function(module, exports) {
module.exports = JSON.parse("{\"description\":\"Added admin insights for TWC - Enterprise\",\"features\":[{\"featureId\":\"provided-allowances\",\"domain\":\"BILLING\",\"value\":{\"allowances\":[{\"reference\":\"allowance_indexed-document\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"indexed-document\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":6250,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":6250,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}},{\"reference\":\"allowance_ai-credit\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"ai-credit\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":1500,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":1500,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}},{\"reference\":\"allowance_assets-objects\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"assets-objects\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":5000},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":5000}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}},{\"reference\":\"allowance_automation-credits\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"automation-credits\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":7500,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":7500,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}}]}}]}");

});

parcelRegister("e5ZMN", function(module, exports) {
module.exports = JSON.parse("{\"description\":\"Support Level added\",\"features\":[]}");

});

parcelRegister("4Y3Fa", function(module, exports) {
module.exports = JSON.parse("{\"description\":\"Added admin insights for TWC - Premium\",\"features\":[{\"featureId\":\"provided-allowances\",\"domain\":\"BILLING\",\"value\":{\"allowances\":[{\"reference\":\"allowance_indexed-document\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"indexed-document\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":2500,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":2500,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}},{\"reference\":\"allowance_ai-credit\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"ai-credit\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":700,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":700,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}},{\"reference\":\"allowance_assets-objects\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"assets-objects\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":5000},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":5000}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}},{\"reference\":\"allowance_automation-credits\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"automation-credits\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":5000,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":5000,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}}]}}]}");

});

parcelRegister("d6TPP", function(module, exports) {
module.exports = JSON.parse("{\"description\":\"Added admin insights for TWC - Standard\",\"features\":[{\"featureId\":\"provided-allowances\",\"domain\":\"BILLING\",\"value\":{\"allowances\":[{\"reference\":\"allowance_indexed-document\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"indexed-document\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":1000,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":1000,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}},{\"reference\":\"allowance_ai-credit\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"ai-credit\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":250,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":250,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}},{\"reference\":\"allowance_assets-objects\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"assets-objects\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":5000},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":5000}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}},{\"reference\":\"allowance_automation-credits\",\"type\":\"ALLOWANCE\",\"config\":{\"usageKey\":\"automation-credits\",\"cycles\":[{\"schedule\":\"BILLING\",\"cycle\":\"MONTHLY\",\"amount\":2500,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}},{\"schedule\":\"BILLING\",\"cycle\":\"ANNUAL\",\"amount\":2500,\"relativeTo\":{\"referenceType\":\"CHARGE_ELEMENT\",\"referenceValue\":\"user\"}}],\"isConsumer\":false,\"recipientEntity\":\"POOL\"}}]}}]}");

});



parcelRegister("5eLaZ", function(module, exports) {
$parcel$export(module.exports, "ORG_USER_COUNT_MIN", function () { return $d3e9646a51defefd$export$53fb25c04d16e0db; });
$parcel$export(module.exports, "ORG_USER_COUNT_MAX", function () { return $d3e9646a51defefd$export$54043737c64deb74; });
$parcel$export(module.exports, "orgUserCountErrorMessages", function () { return $d3e9646a51defefd$export$2b0c565c56827d4d; });
$parcel$export(module.exports, "validateOrgUserCount", function () { return $d3e9646a51defefd$export$1dcb369df61720d4; });

var $fnHPc = parcelRequire("fnHPc");
var $d3e9646a51defefd$export$dac295adacb8b569 = /*#__PURE__*/ function(OrgUserCountError) {
    OrgUserCountError["Required"] = "required";
    OrgUserCountError["NotANumber"] = "notANumber";
    OrgUserCountError["NotInteger"] = "notInteger";
    OrgUserCountError["TooSmall"] = "tooSmall";
    OrgUserCountError["TooLarge"] = "tooLarge";
    return OrgUserCountError;
}({});
const $d3e9646a51defefd$export$53fb25c04d16e0db = 1;
const $d3e9646a51defefd$export$54043737c64deb74 = 1000000;
const $d3e9646a51defefd$export$2b0c565c56827d4d = (0, $fnHPc.defineMessages)({
    required: {
        id: 'ubpQ4.usage.orgUserCount.error.required',
        defaultMessage: 'Organization size is required.'
    },
    notANumber: {
        id: 'ubpQ4.usage.orgUserCount.error.notANumber',
        defaultMessage: 'Organization size must be a number.'
    },
    notInteger: {
        id: 'ubpQ4.usage.orgUserCount.error.notInteger',
        defaultMessage: 'Organization size must be a whole number.'
    },
    tooSmall: {
        id: 'ubpQ4.usage.orgUserCount.error.tooSmall',
        defaultMessage: 'Organization size must be at least {min, number}.'
    },
    tooLarge: {
        id: 'ubpQ4.usage.orgUserCount.error.tooLarge',
        defaultMessage: 'Organization size must be at most {max, number}.'
    }
});
const $d3e9646a51defefd$export$1dcb369df61720d4 = (value)=>{
    if (value === undefined) return "required";
    if (Number.isNaN(value)) return "notANumber";
    if (!Number.isInteger(value)) return "notInteger";
    if (value < $d3e9646a51defefd$export$53fb25c04d16e0db) return "tooSmall";
    if (value > $d3e9646a51defefd$export$54043737c64deb74) return "tooLarge";
    return undefined;
};

});



parcelRegister("ahF4L", function(module, exports) {
$parcel$export(module.exports, "ChoiceCard", function () { return $cbc6c0883735dbaa$export$b0dc71a89abd972a; });
/* choice-card.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $lWOKW = parcelRequire("lWOKW");

var $7H48e = parcelRequire("7H48e");

var $kbpa7 = parcelRequire("kbpa7");

var $bSVv5 = parcelRequire("bSVv5");

var $f3oWf = parcelRequire("f3oWf");
const $cbc6c0883735dbaa$export$b0dc71a89abd972a = ({ value: value, selected: selected, onSelect: onSelect, hide: hide = false, inputType: inputType = 'radio', label: label, description: description, usageInfo: usageInfo, list: list, info: info, iconUrl: iconUrl, lockupUrl: lockupUrl, groupName: groupName })=>{
    const handleClick = (event)=>{
        event.preventDefault();
        onSelect();
    };
    const heading = label;
    if (!hide) return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_kqswh2mm _16jlkb7n _1o9zkb7n _i0dluuw1 _189et94y _1dqonqa1 _1h6d6u2e _2rko1ylz _bfhk1afi _syazrf0c _80omtlke _1e0c1txw _zulputpp _2lx21bp4 _y3gn1e5h _4cvr1y6m _1bah1y6m _vchhusvi",
            selected && "_1h6dftjs _1a3719d8"
        ]),
        style: {
            "--_qtmnbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light300')),
            "--_6td02k": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('corner.radius.card')),
            "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
            "--_ve8pbe": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light1100')),
            "--_16ciuzt": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue800'))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1yt4cufa"
                ]),
                children: inputType === 'checkbox' ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lWOKW.default), {
                    value: String(value),
                    name: groupName ?? `group-${value}`,
                    isChecked: selected,
                    "aria-label": typeof heading === 'string' ? heading : value,
                    testId: `testid${String(value)}`,
                    tabIndex: -1,
                    "aria-hidden": true
                }) : // @ts-expect-error decorative Radio: using card as the real control */}
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7H48e.default), {
                    value: String(value),
                    name: groupName ?? `group-${value}`,
                    isChecked: selected,
                    "aria-label": typeof heading === 'string' ? heading : undefined,
                    testId: `testid${String(value)}`,
                    tabIndex: -1,
                    "aria-hidden": true
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1yt41310 _1e0c1txw _2lx21bp4 _4cvr1y6m _zulpv47k"
                ]),
                children: [
                    heading && /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_kmft11p5 _1hxk1h6o _wsm11r0c _mncspxbi",
                            `icon_${iconUrl ? 'true' : 'false'}`
                        ]),
                        children: [
                            iconUrl && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                                src: iconUrl,
                                alt: "",
                                className: (0, $2jatx.default)([
                                    "_1e0c1ule _1bsbckbl _4t3ickbl _5ral1f51"
                                ])
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                                className: (0, $2jatx.default)([
                                    "_ect41vau _vwz4kb7n _19pkidpf _2hwxidpf _otyridpf _18u0idpf _k48pni7l"
                                ]),
                                style: {
                                    "--_1vugql0": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.display'))
                                },
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                    className: (0, $2jatx.default)([
                                        "_1wyb1k8s _vwz4kb7n"
                                    ]),
                                    children: heading
                                })
                            })
                        ]
                    }),
                    lockupUrl && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                        src: lockupUrl,
                        alt: "",
                        className: (0, $2jatx.default)([
                            "_1e0c1ule _4t3ickbl _1bsb1wug _5ral1f51"
                        ])
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_ect4z4z1 _1wyb1af2 _18s861nu"
                        ]),
                        style: {
                            "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text'))
                        },
                        children: description
                    }),
                    usageInfo && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_k48p1fw0 _ect4z4z1 _1wyb1af2 _18s861nu"
                        ]),
                        style: {
                            "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text'))
                        },
                        children: usageInfo
                    }),
                    list && list.length > 0 && /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
                        className: (0, $2jatx.default)([
                            "_1yt41qut _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                        ]),
                        children: list.map((listItem, index)=>{
                            const IconMapped = listItem.icon ? (0, $f3oWf.iconMapping)[listItem.icon]?.component : undefined;
                            const hasIcon = Boolean(IconMapped);
                            return /*#__PURE__*/ (0, $7VQPk.jsxs)("li", {
                                className: (0, $2jatx.default)([
                                    "_ect4z4z1 _1wyb1af2 _18s8vjyi _kqswh2mm",
                                    hasIcon && "_2mzuglyw"
                                ]),
                                style: {
                                    "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text'))
                                },
                                children: [
                                    hasIcon && IconMapped && /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                        className: (0, $2jatx.default)([
                                            "_syazu5k9 _kqswstnw _1e02c7mi _1ul966rk"
                                        ]),
                                        style: {
                                            "--_5dnsy5": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue700'))
                                        },
                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)(IconMapped, {
                                            size: "small"
                                        })
                                    }),
                                    listItem.text
                                ]
                            }, `${value}-list-${index}`);
                        })
                    })
                ]
            }),
            info && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1pfh1wug _1bsb1osq _bfhk1bjw _2rko8sxs _1yt4utpp _ect4z4z1 _1wyb1af2 _y3gn1h6o"
                ]),
                style: {
                    "--_lwvw50": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue100')),
                    "--_6td02k": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('corner.radius.card')),
                    "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text'))
                },
                children: info
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                type: "button",
                onClick: handleClick,
                role: inputType,
                "aria-checked": selected,
                "aria-label": typeof heading === 'string' ? heading : value,
                className: (0, $2jatx.default)([
                    "_r06hglyw _19itidpf _2rko1kw7 _11q7glyw _kqswstnw _1r041n1a _80omtlke _1ygb1sw7 _1ah3j39m"
                ]),
                style: {
                    "--_16ciuzt": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue800'))
                }
            })
        ]
    });
    return null;
};
/* eslint-enable complexity */ const $cbc6c0883735dbaa$var$cardStyle = null;
const $cbc6c0883735dbaa$var$cardSelectedStyle = null;
const $cbc6c0883735dbaa$var$selectorOverlayStyle = null;
const $cbc6c0883735dbaa$var$radioContainer = null;
const $cbc6c0883735dbaa$var$textContainer = null;
const $cbc6c0883735dbaa$var$headingContainer = null;
const $cbc6c0883735dbaa$var$cardHeading = null;
const $cbc6c0883735dbaa$var$cardHeadingSpan = null;
const $cbc6c0883735dbaa$var$cardDescription = null;
const $cbc6c0883735dbaa$var$usageInfoStyle = null;
const $cbc6c0883735dbaa$var$listContainer = null;
const $cbc6c0883735dbaa$var$listElement = null;
const $cbc6c0883735dbaa$var$listElementWithIcon = null;
const $cbc6c0883735dbaa$var$iconImageStyle = null;
const $cbc6c0883735dbaa$var$lockupImageStyle = null;
const $cbc6c0883735dbaa$var$iconStyle = null;
const $cbc6c0883735dbaa$var$infoBoxStyle = null;

});

parcelRegister("cNQe2", function(module, exports) {
$parcel$export(module.exports, "useAppDescriptions", function () { return $9e7fccd22b36f20f$export$ab9f7780451346ce; });
$parcel$export(module.exports, "useCollectionDescriptions", function () { return $9e7fccd22b36f20f$export$b81506d4e90a8621; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $iRMRa = parcelRequire("iRMRa");
const $9e7fccd22b36f20f$export$ab9f7780451346ce = ()=>{
    const intl = (0, $8e22h.default)();
    return (0, $1oC0p.useMemo)(()=>({
            jira: {
                label: 'Jira',
                iconUrl: 'https://dam-cdn.atl.orangelogic.com/AssetLink/478vdip7223r1idsl83luxcl3x6d8153.svg',
                description: intl.formatMessage({
                    id: 'ubp.calculator.apps.jira.description',
                    defaultMessage: 'Flexible project management'
                })
            },
            confluence: {
                label: 'Confluence',
                iconUrl: 'https://dam-cdn.atl.orangelogic.com/AssetLink/yria5c22578g421umx80xu14m77622ej.svg',
                description: intl.formatMessage({
                    id: 'ubp.calculator.apps.confluence.description',
                    defaultMessage: 'Knowledge, all in one place'
                })
            },
            jpd: {
                label: 'Jira Product Discovery',
                iconUrl: 'https://dam-cdn.atl.orangelogic.com/AssetLink/06wk2ma2fw3fde5d2pu7r04r770862g4.svg',
                description: intl.formatMessage({
                    id: 'ubp.calculator.apps.jpd.description',
                    defaultMessage: 'Capture and prioritize ideas'
                })
            },
            talent: {
                label: 'Talent',
                iconUrl: 'https://dam-cdn.atl.orangelogic.com/AssetLink/o5qs3j2vg750dyht575e48jabmgj613u.svg',
                description: intl.formatMessage({
                    id: 'ubp.calculator.apps.talent.description',
                    defaultMessage: 'Knowledge workforce planning'
                })
            },
            loom: {
                label: 'Loom',
                iconUrl: 'https://dam-cdn.atl.orangelogic.com/AssetLink/l1a7wcg5v75rwod3kxt31h380e4s7yr1.svg',
                description: intl.formatMessage({
                    id: 'ubp.calculator.apps.loom.description',
                    defaultMessage: 'Quick, async video updates'
                })
            },
            jsm: {
                label: 'Jira Service Management',
                iconUrl: 'https://dam-cdn.atl.orangelogic.com/AssetLink/bafh8247s17543215301yjy1iaw6lgon.svg',
                description: intl.formatMessage({
                    id: 'ubp.calculator.apps.jsm.description',
                    defaultMessage: 'High-velocity service delivery'
                })
            }
        }), [
        intl
    ]);
};
const $9e7fccd22b36f20f$export$b81506d4e90a8621 = ()=>{
    const intl = (0, $8e22h.default)();
    return (0, $1oC0p.useMemo)(()=>({
            teamworkCollection: {
                lockupUrl: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT1ULE7.svg',
                shortDescription: intl.formatMessage({
                    id: 'ubp.calculator.collections.teamwork.shortDescription',
                    defaultMessage: 'Plan, document, and deliver together'
                }),
                description: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "ubp.calculator.collections.teamwork.description",
                    defaultMessage: "Everything your team needs to plan, document, and deliver\u2014all in one place.<br></br><br></br>Includes licensing for the following apps:",
                    values: (0, $iRMRa.DEFAULT_VALUES)
                }),
                list: [
                    {
                        text: intl.formatMessage({
                            id: 'ubp.calculator.collections.teamwork.list.one',
                            defaultMessage: 'Jira; For flexible project management'
                        })
                    },
                    {
                        text: intl.formatMessage({
                            id: 'ubp.calculator.collections.teamwork.list.two',
                            defaultMessage: 'Confluence; Knowledge all in one place'
                        })
                    },
                    {
                        text: intl.formatMessage({
                            id: 'ubp.calculator.collections.teamwork.list.three',
                            defaultMessage: 'Loom; AI-powered video msgs'
                        })
                    },
                    {
                        text: intl.formatMessage({
                            id: 'ubp.calculator.collections.teamwork.list.four',
                            defaultMessage: 'Rovo; Transform teamwork with AI'
                        })
                    }
                ]
            },
            serviceCollection: {
                lockupUrl: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12O5B2.svg',
                shortDescription: intl.formatMessage({
                    id: 'ubp.calculator.collections.service.shortDescription',
                    defaultMessage: 'High-velocity service delivery, at scale'
                }),
                description: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "ubp.calculator.collections.service.description",
                    defaultMessage: "Set strategic priorities, allocate investments, and see real-time portfolio progress in a single view.<br></br><br></br>Includes licensing for the following apps:",
                    values: (0, $iRMRa.DEFAULT_VALUES)
                }),
                list: [
                    {
                        text: intl.formatMessage({
                            id: 'ubp.calculator.collections.serviceCollection.list.one',
                            defaultMessage: 'Jira Service Management; Deliver service at high velocity'
                        })
                    },
                    {
                        text: intl.formatMessage({
                            id: 'ubp.calculator.collections.serviceCollection.list.two',
                            defaultMessage: 'Customer Service Management; Customer experiences reimagined'
                        })
                    },
                    {
                        text: intl.formatMessage({
                            id: 'ubp.calculator.collections.serviceCollection.list.three',
                            defaultMessage: 'Assets; Track what matters'
                        })
                    },
                    {
                        text: intl.formatMessage({
                            id: 'ubp.calculator.collections.serviceCollection.list.four',
                            defaultMessage: 'Rovo; Team up with AI'
                        })
                    }
                ]
            },
            productCollection: {
                lockupUrl: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12MOBS.svg',
                shortDescription: intl.formatMessage({
                    id: 'ubp.calculator.collections.product.shortDescription',
                    defaultMessage: 'Strategic priorities, aligned to your portfolio'
                }),
                description: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "ubp.calculator.collections.product.description",
                    defaultMessage: "Set strategic priorities, allocate investments, and see real-time portfolio progress in a single view.<br></br><br></br>Includes licensing for the following apps:",
                    values: (0, $iRMRa.DEFAULT_VALUES)
                }),
                list: [
                    {
                        text: intl.formatMessage({
                            id: 'ubp.calculator.collections.productCollection.list.one',
                            defaultMessage: 'Focus; Intelligent strategic planning'
                        })
                    },
                    {
                        text: intl.formatMessage({
                            id: 'ubp.calculator.collections.productCollection.list.two',
                            defaultMessage: 'Talent; Knowledge workforce planning'
                        })
                    },
                    {
                        text: intl.formatMessage({
                            id: 'ubp.calculator.collections.productCollection.list.three',
                            defaultMessage: 'Align; Enterprise portfolio execution'
                        })
                    },
                    {
                        text: intl.formatMessage({
                            id: 'ubp.calculator.collections.productCollection.list.four',
                            defaultMessage: 'Rovo; Transform strategy with AI'
                        })
                    }
                ]
            }
        }), [
        intl
    ]);
};

});

parcelRegister("ehiBJ", function(module, exports) {
$parcel$export(module.exports, "StepNav", function () { return $db272d046543180a$export$85e4c3883d02a5f; });
/* step-nav.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $lqyi6 = parcelRequire("lqyi6");

var $4xsw0 = parcelRequire("4xsw0");
const $db272d046543180a$export$85e4c3883d02a5f = (props)=>{
    const { showBack: showBack = false, showNext: showNext = false, showSkip: showSkip = false, nextDisabled: nextDisabled = false, skipTo: skipTo, nextLabel: nextLabel = 'Next' } = props;
    const prev = (0, $4xsw0.useGoToPrevStep)();
    const next = (0, $4xsw0.useGoToNextStep)();
    const setStep = (0, $4xsw0.useSetStep)();
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _zulp1crf _1q51tudo _1bsb1osq"
        ]),
        children: [
            showBack && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
                variant: "secondary",
                onClick: prev,
                children: "Back"
            }),
            showSkip && skipTo && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
                variant: "secondary",
                onClick: ()=>setStep(skipTo),
                children: "Skip"
            }),
            showNext && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
                variant: "primary",
                isDisabled: nextDisabled,
                onClick: next,
                children: nextLabel
            })
        ]
    });
};
// Centered nav row with 76px top padding per Figma. Buttons flow horizontally
// with a small gap between them.
const $db272d046543180a$var$navRowStyle = null;

});

parcelRegister("cIZNT", function(module, exports) {
$parcel$export(module.exports, "Stepper", function () { return $523f115dd120cc39$export$ed8ca599049e8881; });
/* stepper.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $kbpa7 = parcelRequire("kbpa7");

var $4xsw0 = parcelRequire("4xsw0");

var $hSUNh = parcelRequire("hSUNh");
const $523f115dd120cc39$export$ed8ca599049e8881 = ()=>{
    const currentIndex = (0, $4xsw0.useSelector)((0, $hSUNh.selectStepIndex));
    const intl = (0, $8e22h.default)();
    const navSteps = (0, $1oC0p.useMemo)(()=>[
            intl.formatMessage({
                id: 'ubp.calculator.topnav.usage',
                defaultMessage: 'Usage'
            }),
            intl.formatMessage({
                id: 'ubp.calculator.topnav.needs',
                defaultMessage: 'Needs'
            }),
            intl.formatMessage({
                id: 'ubp.calculator.topnav.estimate',
                defaultMessage: 'Estimate'
            }),
            intl.formatMessage({
                id: 'ubp.calculator.topnav.allowance',
                defaultMessage: 'Allowance'
            }),
            intl.formatMessage({
                id: 'ubp.calculator.topnav.summary',
                defaultMessage: 'Summary'
            })
        ], [
        intl
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1e0c11p5 _wij21bp4 _1ejihkll _1bsb1osq _p12f1ogm _19pk1wug _2hwx1wug _otyr1wug _18u01wug"
        ]),
        children: navSteps.map((navStep, index)=>{
            return /*#__PURE__*/ (0, $7VQPk.jsx)($523f115dd120cc39$var$StepperItem, {
                index: index,
                currentIndex: currentIndex,
                label: navStep,
                isLast: index === navSteps.length - 1
            }, `step${index}`);
        })
    });
};
const $523f115dd120cc39$var$StepperItem = (props)=>{
    const { label: label, index: index, currentIndex: currentIndex, isLast: isLast } = props;
    const isPast = index < currentIndex;
    const isFuture = index > currentIndex;
    const isCurrent = index === currentIndex;
    const isFirst = index === 0;
    const leftColor = isFirst ? 'transparent' : isCurrent || isPast ? (0, $kbpa7.wacToken)('color.primary.blue') : (0, $kbpa7.wacToken)('color.neutral.light400');
    const rightColor = isLast ? 'transparent' : isCurrent || isFuture ? (0, $kbpa7.wacToken)('color.neutral.light400') : (0, $kbpa7.wacToken)('color.primary.blue');
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        style: {
            backgroundImage: `linear-gradient(to right, ${leftColor} 0 50%, ${rightColor} 50% 100%)`
        },
        className: (0, $2jatx.default)([
            "_1lrw5kut _ouxl81bl _12vemgnk _1e0c1txw _zulpu2gc _4cvr1h6o _2lx21bp4"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_bfhkdkka _syaz1pfd _1bsb7vkz _4t3i7vkz _2rko1ssb _1dqonqa1 _189et94y _1h6ds3kk _1wyb19bv _1e0c1txw _4cvr1h6o _1bah1h6o _16jlidpf _1o9zidpf _i0dl1wug _ga7t5hrz _1ob55hrz _1f4d1afi",
                    `active-${isPast || isCurrent}`
                ]),
                style: {
                    "--_1kg2hiy": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light200')),
                    "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                    "--_1xfz4lx": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light400')),
                    "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue')),
                    "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
                },
                children: isPast ? /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    version: "1.2",
                    viewBox: "0 0 16 16",
                    width: "16",
                    height: "16",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        fill: "white",
                        fillRule: "evenodd",
                        d: "m6.75 9.83l-1.92-2.31-1.16 0.96 2.5 3q0.23 0.26 0.58 0.27 0.35-0.01 0.58-0.27l5-6-1.16-0.96z"
                    })
                }) : index + 1
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1wyb1crf _syaz1pfd _1f4d5hrz",
                    `active-${isPast || isCurrent}`
                ]),
                style: {
                    "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                    "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
                },
                children: label
            })
        ]
    });
};
const $523f115dd120cc39$var$stepperItemCss = null;
const $523f115dd120cc39$var$stepperRowStyle = null;
const $523f115dd120cc39$var$stepperCircle = null;
const $523f115dd120cc39$var$stepperLabelStyle = null;

});


parcelRegister("9wpUt", function(module, exports) {
$parcel$export(module.exports, "OrgNeedsCard", function () { return $61c70cc4030e4911$export$5898efc876ac2fef; });
$parcel$export(module.exports, "ExampleUsage", function () { return $61c70cc4030e4911$export$335b18f104030e5f; });
$parcel$export(module.exports, "METER_LABELS_LOWER", function () { return $61c70cc4030e4911$export$28833053b5e4afa6; });
$parcel$export(module.exports, "EstimateStep", function () { return $61c70cc4030e4911$export$fe759901621fb73d; });
$parcel$export(module.exports, "panelStyle", function () { return $61c70cc4030e4911$export$abcda1a9465218a0; });
$parcel$export(module.exports, "panelTitleStyle", function () { return $61c70cc4030e4911$export$7a56d429868e2274; });
$parcel$export(module.exports, "columnStackStyle", function () { return $61c70cc4030e4911$export$93dd9b65c49182d4; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2axoc = parcelRequire("2axoc");

var $iPPTB = parcelRequire("iPPTB");

var $kbpa7 = parcelRequire("kbpa7");

var $jsxHL = parcelRequire("jsxHL");

var $73KXs = parcelRequire("73KXs");

var $4xsw0 = parcelRequire("4xsw0");

var $hSUNh = parcelRequire("hSUNh");

var $kdccD = parcelRequire("kdccD");

var $8kSAg = parcelRequire("8kSAg");

var $8wHAz = parcelRequire("8wHAz");

var $iZlze = parcelRequire("iZlze");

var $93kHd = parcelRequire("93kHd");

var $f8Axo = parcelRequire("f8Axo");

var $cIZNT = parcelRequire("cIZNT");

var $f1WTS = parcelRequire("f1WTS");
const $61c70cc4030e4911$export$5898efc876ac2fef = ()=>{
    const meter = (0, $4xsw0.useSelector)((0, $hSUNh.selectMeter));
    const usageType = (0, $4xsw0.useSelector)((0, $hSUNh.selectUsageType));
    const setUsageType = (0, $4xsw0.useSetUsageType)();
    const { low: low, high: high } = (0, $4xsw0.useSelector)((0, $hSUNh.selectEstimatedUsageRange));
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $93kHd.ResultsCard), {
        eyebrow: "YOUR ORGANIZATION NEEDS",
        headline: `${low.toLocaleString('en-US')}\u{2013}${high.toLocaleString('en-US')}`,
        headlineSubtext: `${(0, $f1WTS.METER_LABELS)[meter]} per month`,
        dropdown: {
            ariaLabel: 'Usage type',
            options: [
                {
                    value: 'exploring',
                    label: 'Exploring'
                },
                {
                    value: 'adopting',
                    label: 'Adopting'
                },
                {
                    value: 'scaling',
                    label: 'Scaling'
                }
            ],
            value: usageType,
            onChange: (value)=>setUsageType(value)
        },
        testId: "estimate-org-needs"
    });
};
const $61c70cc4030e4911$export$335b18f104030e5f = ()=>{
    const meter = (0, $4xsw0.useSelector)((0, $hSUNh.selectMeter));
    const goToNext = (0, $4xsw0.useGoToNextStep)();
    // Uses the design-library ContentBlock so the section matches Figma
    // node 1103:32363 ("Content Blocks Vertical") and inherits the WAC
    // design-system typography, spacing, and image treatment (16:9,
    // rounded corners). Do NOT swap this for a wpl/ component — see the
    // "Component Sourcing Rule" in wac/AGENTS.md.
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2axoc.ContentBlock), {
        title: "Explore how Atlassian Collections and apps align to your usage needs.",
        titleAs: "h3",
        titleAppearsAs: "card-title",
        // Structured content per Figma node 1103:32363: intro paragraph
        // + a small bulleted list. Passed as a single React element (a
        // `<div>`) so it satisfies ContentBlock's `text: string |
        // ReactElement` prop shape. The ContentBlock renders elements
        // as-is (no `body-lg`/`body-md` wrapping), so the caller uses
        // `body-md` classes to keep the typography consistent with the
        // default string rendering.
        text: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: "body-md",
            style: {
                display: 'flex',
                flexDirection: 'column',
                gap: '12px'
            },
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                    style: {
                        margin: 0
                    },
                    children: `How your teams might use ${$61c70cc4030e4911$export$28833053b5e4afa6[meter]} and choose the right plan for your organization.`
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)("ul", {
                    style: {
                        margin: 0,
                        paddingInlineStart: '1.25rem',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '4px'
                    },
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                            children: "Maximize your ROI"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                            children: "Plan with confidence"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                            children: "Unlock more with less"
                        })
                    ]
                })
            ]
        }),
        alignment: "start",
        orientation: "vertical",
        imageAspectRatio: "16 / 9",
        imageProps: {
            // TEMPORARY: reusing an existing Orange Logic hero webp from
            // other wac-web stories as a placeholder while the marketing
            // team finalizes the Rovo/Atlassian Collections hero asset.
            // Track replacement in the follow-up content ticket.
            src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/2647y7t555mmx4e1r8gkni4v10l540nr.webp',
            alt: ''
        },
        // Small secondary button per Figma node 1103:32350. The
        // ContentBlock's default button size is derived from title
        // semantics (`h4` → small, else large). Since our title is
        // visually h3-sized, we opt into the compact `small` size
        // explicitly via the new `buttonSize` override.
        //
        // The CTA doubles as the Estimate step's "Next" action — clicking
        // it advances the calculator to the Summary step. This is why
        // the Estimate step's StepNav omits `showNext`: the ContentBlock
        // button IS the forward navigation for this step.
        buttonSize: "small",
        callToActionProps: {
            buttonText: 'Compare now',
            buttonVariant: 'secondary',
            button: {
                type: 'button',
                onClick: (e)=>{
                    e.preventDefault();
                    goToNext();
                }
            }
        }
    });
};
const $61c70cc4030e4911$export$65a74acb094c9303 = ()=>{
    const meter = (0, $4xsw0.useSelector)((0, $hSUNh.selectMeter));
    const meterLabel = $61c70cc4030e4911$export$28833053b5e4afa6[meter];
    // Placeholder marketing copy — the content team will provide the final
    // strings per meter in a follow-up. Kept meter-aware so the section
    // adapts to selection immediately when copy lands.
    const valueProps = [
        {
            title: 'Value prop 1 for type',
            description: `Value prop 1 for ${meterLabel} description.`
        },
        {
            title: 'Value prop 2 for type',
            description: `Value prop 2 for ${meterLabel} description.`
        },
        {
            title: 'Value prop 3 for type',
            description: `Value prop 3 for ${meterLabel} description.`
        }
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        style: $61c70cc4030e4911$var$howYourTeamsMightUseStyle,
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                style: $61c70cc4030e4911$var$howYourTeamsMightUseEyebrowStyle,
                children: "How your teams might use"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                style: $61c70cc4030e4911$var$valuePropStackStyle,
                children: valueProps.map((vp, i)=>/*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        style: $61c70cc4030e4911$var$valuePropItemStyle,
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                style: $61c70cc4030e4911$var$valuePropTitleStyle,
                                children: vp.title
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                style: $61c70cc4030e4911$var$valuePropDescriptionStyle,
                                children: vp.description
                            })
                        ]
                    }, `${vp.title}-${i}`))
            })
        ]
    });
};
const $61c70cc4030e4911$export$fe759901621fb73d = ()=>{
    const meter = (0, $4xsw0.useSelector)((0, $hSUNh.selectMeter));
    const goToPrev = (0, $4xsw0.useGoToPrevStep)();
    // Feedback vote is component-local. Follow-up ticket wires this to
    // analytics + persistence.
    const [vote, setVote] = (0, $1oC0p.useState)(null);
    // Build a real, valid href for the Back link that points at the same
    // calculator URL with `step` set to the previous step. This lets the
    // anchor be a semantically-real link (bookmarkable, right-clickable,
    // opens-in-new-tab) — the onClick below prevents the full page reload
    // and drives the calculator state machine instead.
    const shareableQuery = (0, $4xsw0.useSelector)((0, $hSUNh.selectShareableQuery));
    const currentStep = (0, $4xsw0.useSelector)((ctx)=>ctx.step);
    const prevStep = (0, $73KXs.STEP_ORDER)[(0, $73KXs.STEP_ORDER).indexOf(currentStep) - 1];
    const prevStepHref = prevStep ? `?${(0, $kdccD.toQueryString)({
        ...shareableQuery,
        step: prevStep
    })}` : '?';
    if (meter === 'csResolutions') return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8kSAg.EstimateCsrStep), {});
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cIZNT.Stepper), {}),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jsxHL.TypographyStyles), {
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    style: $61c70cc4030e4911$var$pageHeaderStyle,
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                            style: $61c70cc4030e4911$var$pageTitleStyle,
                            children: "Estimate Summary"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                            style: $61c70cc4030e4911$var$pageSubtitleStyle,
                            children: "Based on what you\u2019ve told us, here\u2019s a summary of how many credits you need, and how you can use them."
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                style: $61c70cc4030e4911$var$twoColumnRowStyle,
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        style: $61c70cc4030e4911$var$twoColumnLeftStyle,
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)($61c70cc4030e4911$export$5898efc876ac2fef, {}),
                            /*#__PURE__*/ (0, $7VQPk.jsx)($61c70cc4030e4911$export$65a74acb094c9303, {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        style: $61c70cc4030e4911$var$twoColumnRightStyle,
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)($61c70cc4030e4911$export$335b18f104030e5f, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                style: $61c70cc4030e4911$var$feedbackWrapperStyle,
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iZlze.FeedbackButtons), {
                    vote: vote,
                    onVote: setVote
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                style: $61c70cc4030e4911$var$bottomActionRowStyle,
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                        type: "primary",
                        size: "md",
                        text: "Back",
                        ariaLabel: "Back",
                        href: prevStepHref,
                        onClick: (e)=>{
                            e.preventDefault();
                            goToPrev();
                        },
                        showArrow: false,
                        showUnderline: false
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $f8Axo.ShareButton), {})
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8wHAz.EstimateDisclaimer), {})
        ]
    });
};
const $61c70cc4030e4911$export$28833053b5e4afa6 = {
    rovoCredits: 'rovo credits',
    automations: 'automations',
    csResolutions: 'CS resolutions',
    assetsObjects: 'assets objects'
};
const $61c70cc4030e4911$export$abcda1a9465218a0 = {
    padding: 16,
    border: `1px solid ${(0, $kbpa7.wacToken)('color.neutral.light300')}`,
    borderRadius: 8,
    backgroundColor: (0, $kbpa7.wacToken)('color.neutral.light100'),
    height: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column'
};
const $61c70cc4030e4911$export$7a56d429868e2274 = {
    margin: '0 0 12px',
    fontSize: 16,
    fontWeight: 700,
    color: (0, $kbpa7.wacToken)('color.neutral.light1100')
};
/**
 * Estimate step header / bottom-action-row styles.
 *
 * The old `stepTitleStyle` (a plain 22px bold heading) was removed —
 * the Estimate step now uses the design-system H3 + body-large pattern
 * (see `pageTitleStyle` / `pageSubtitleStyle` below), consistent with
 * the other calculator steps.
 */ const $61c70cc4030e4911$var$pageHeaderStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    // 40px above the H3 (between the Stepper and the title) and 40px below
    // the subtitle (before the cards start), per Figma node 1103:32350.
    paddingBlock: '40px'
};
const $61c70cc4030e4911$var$pageTitleStyle = {
    // TypographyStyles maps raw `h3` to Charlie Display Bold 32/38 —
    // matches Figma spec (node 1103:32354).
    margin: 0
};
const $61c70cc4030e4911$var$pageSubtitleStyle = {
    // Body Large: Charlie Text Regular 20/28, matches Figma node 1103:32357.
    margin: 0,
    fontSize: '20px',
    lineHeight: '28px',
    fontWeight: 400,
    color: (0, $kbpa7.wacToken)('color.neutral.light1100')
};
const $61c70cc4030e4911$var$bottomActionRowStyle = {
    display: 'flex',
    // Vertically center Back + Share on a single row per Figma.
    alignItems: 'center',
    // Horizontally centered per Figma — Back + Copy URL sit in the middle
    // of the calculator container, with a 12px gap between them (matches
    // the gap used inside StepNav for visual consistency).
    justifyContent: 'center',
    gap: '12px',
    paddingBlockStart: '40px'
};
// "How your teams might use" section — value cards without icons.
// Neutral-light-100 panel (matches ResultsCard) with 20px inside padding
// and 20px rounded corners. Content is a stack of bold title + description
// pairs with 24px between items (matches Figma 1103:32350).
const $61c70cc4030e4911$var$howYourTeamsMightUseStyle = {
    backgroundColor: (0, $kbpa7.wacToken)('color.neutral.light100'),
    borderRadius: '20px',
    padding: '20px 20px 32px 20px',
    display: 'flex',
    flexDirection: 'column',
    gap: '24px'
};
const $61c70cc4030e4911$var$howYourTeamsMightUseEyebrowStyle = {
    margin: 0,
    fontFamily: (0, $kbpa7.wacToken)('font.charlie.text'),
    fontSize: '14px',
    lineHeight: '18px',
    fontWeight: 400,
    textTransform: 'uppercase',
    letterSpacing: 0,
    color: (0, $kbpa7.wacToken)('color.neutral.light1100')
};
const $61c70cc4030e4911$var$valuePropStackStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px'
};
const $61c70cc4030e4911$var$valuePropItemStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: 0
};
const $61c70cc4030e4911$var$valuePropTitleStyle = {
    margin: 0,
    fontFamily: (0, $kbpa7.wacToken)('font.charlie.text'),
    fontSize: '16px',
    lineHeight: '24px',
    fontWeight: 700,
    color: (0, $kbpa7.wacToken)('color.neutral.light1100')
};
const $61c70cc4030e4911$var$valuePropDescriptionStyle = {
    margin: 0,
    fontFamily: (0, $kbpa7.wacToken)('font.charlie.text'),
    fontSize: '16px',
    lineHeight: '24px',
    fontWeight: 400,
    color: (0, $kbpa7.wacToken)('color.neutral.light1100')
};
// Two-column layout for the main Estimate step content sections.
// Uses `grid-template-columns: repeat(auto-fit, minmax(400px, 1fr))` so
// the grid intrinsically collapses to a single column below the WAC `sm`
// breakpoint (roughly viewports < 832px) without needing a media query.
// This keeps the layout styleable with plain inline styles.
const $61c70cc4030e4911$var$twoColumnRowStyle = {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))',
    gap: '32px',
    alignItems: 'start'
};
// Left column — stacks OrgNeedsCard on top of HowYourTeamsMightUse.
const $61c70cc4030e4911$var$twoColumnLeftStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px'
};
// Right column — holds the ExampleUsage ContentBlock. Explicit wrapper
// (rather than just placing ExampleUsage directly) keeps parallel styling
// hooks available if the right side needs its own gap/padding later.
const $61c70cc4030e4911$var$twoColumnRightStyle = {
    display: 'flex',
    flexDirection: 'column'
};
// Wrapper for the FeedbackButtons section — 56px above (40 + 16) and
// 44px below (40 + 4) per the design's spacing spec on top of the base
// 40px rhythm. Horizontally centered per Figma.
const $61c70cc4030e4911$var$feedbackWrapperStyle = {
    display: 'flex',
    justifyContent: 'center',
    paddingBlockStart: '56px',
    paddingBlockEnd: '44px'
};
const $61c70cc4030e4911$export$93dd9b65c49182d4 = {
    display: 'flex',
    flexDirection: 'column',
    gap: 16
};
const $61c70cc4030e4911$export$2d90ecca2320557a = {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: 16,
    alignItems: 'stretch'
};

});
parcelRegister("kdccD", function(module, exports) {
$parcel$export(module.exports, "toQueryString", function () { return $c08b1e7b47753322$export$249cc09c933c4d7a; });
$parcel$export(module.exports, "fromQueryString", function () { return $c08b1e7b47753322$export$654b5b3040c9f223; });
/**
 * Generic URL query-string helpers. These are intentionally business-logic
 * agnostic — they know how to serialize/deserialize plain values, arrays and
 * nested key/value records, but they do not know anything about the UBP
 * domain model.
 */ const $c08b1e7b47753322$export$249cc09c933c4d7a = (values)=>{
    const params = new URLSearchParams();
    for (const [key, value] of Object.entries(values)){
        if (value === undefined || value === null) continue;
        if (Array.isArray(value)) for (const v of value)params.append(`${key}[]`, String(v));
        else if (typeof value === 'object') for (const [subKey, subValue] of Object.entries(value)){
            if (subValue === undefined || subValue === null) continue;
            params.append(`${key}.${subKey}`, String(subValue));
        }
        else params.append(key, String(value));
    }
    return params.toString();
};
const $c08b1e7b47753322$export$654b5b3040c9f223 = (search)=>{
    const params = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search);
    const result = {
        scalars: {},
        arrays: {},
        nested: {}
    };
    params.forEach((value, rawKey)=>{
        if (rawKey.endsWith('[]')) {
            const key = rawKey.slice(0, -2);
            (result.arrays[key] ??= []).push(value);
        } else if (rawKey.includes('.')) {
            // Split on the LAST `.` so that multi-segment parents like
            // `product.jira` are preserved (parent = `product.jira`,
            // subKey = `units`).
            const lastDot = rawKey.lastIndexOf('.');
            const parent = rawKey.slice(0, lastDot);
            const subKey = rawKey.slice(lastDot + 1);
            (result.nested[parent] ??= {})[subKey] = value;
        } else result.scalars[rawKey] = value;
    });
    return result;
};

});

parcelRegister("8kSAg", function(module, exports) {
$parcel$export(module.exports, "EstimateCsrStep", function () { return $fca650912819de9f$export$4b32560747c97afa; });

var $7VQPk = parcelRequire("7VQPk");

var $kbpa7 = parcelRequire("kbpa7");

var $9wpUt = parcelRequire("9wpUt");

var $f8Axo = parcelRequire("f8Axo");

var $ehiBJ = parcelRequire("ehiBJ");

var $cIZNT = parcelRequire("cIZNT");
const $fca650912819de9f$export$4b32560747c97afa = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cIZNT.Stepper), {}),
            /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                style: $fca650912819de9f$var$stepTitleStyle,
                children: "Estimate"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                style: (0, $9wpUt.columnStackStyle),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        style: $fca650912819de9f$var$splitThirdsRowStyle,
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9wpUt.OrgNeedsCard), {}),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                style: (0, $9wpUt.panelStyle),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                                    style: (0, $9wpUt.panelTitleStyle),
                                    children: "Monthly Cost estimate"
                                })
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9wpUt.ExampleUsage), {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)($fca650912819de9f$var$CustomValueCard, {})
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ehiBJ.StepNav), {
                showBack: true
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $f8Axo.ShareButton), {})
        ]
    });
const $fca650912819de9f$var$CustomValueCard = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        style: (0, $9wpUt.panelStyle),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                style: (0, $9wpUt.panelTitleStyle),
                children: "Get Service Collection to use with your CS Resolutions"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                style: $fca650912819de9f$var$bodyTextStyle,
                children: "Elevate support experiences, keep critical services running, and deliver value fast."
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                style: $fca650912819de9f$var$linkStyle,
                href: "/collections/service/pricing",
                children: "Explore Service Collection"
            })
        ]
    });
const $fca650912819de9f$var$splitThirdsRowStyle = {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: 16,
    alignItems: 'stretch'
};
// Local copies of the two styles previously exported from estimate-step.tsx.
// The main Estimate step no longer needs them (CTA is now a design-library
// button in a ContentBlock), so they live here alongside their sole remaining
// caller — the CSR-specific `CustomValueCard`.
const $fca650912819de9f$var$bodyTextStyle = {
    margin: '0 0 12px',
    fontSize: 14,
    color: (0, $kbpa7.wacToken)('color.neutral.light1100')
};
const $fca650912819de9f$var$linkStyle = {
    fontSize: 14,
    fontWeight: 600,
    color: (0, $kbpa7.wacToken)('color.primary.blue'),
    textDecoration: 'none',
    cursor: 'pointer',
    alignSelf: 'flex-start'
};
// Local copy of the plain 22px section title. The main Estimate step now
// uses the design-system H3 + body-large header pattern; the CSR variant
// hasn't been redesigned yet so it keeps its original heading treatment.
const $fca650912819de9f$var$stepTitleStyle = {
    margin: 0,
    fontSize: 22,
    fontWeight: 700,
    color: (0, $kbpa7.wacToken)('color.neutral.light1100')
};

});
parcelRegister("f8Axo", function(module, exports) {
$parcel$export(module.exports, "ShareButton", function () { return $0c13ec0efd8426d8$export$e980dfbc2840e8bc; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $deg4B = parcelRequire("deg4B");

var $lqyi6 = parcelRequire("lqyi6");

var $4xsw0 = parcelRequire("4xsw0");

var $hSUNh = parcelRequire("hSUNh");

var $kdccD = parcelRequire("kdccD");
const $0c13ec0efd8426d8$export$e980dfbc2840e8bc = ()=>{
    const query = (0, $4xsw0.useSelector)((0, $hSUNh.selectShareableQuery));
    const [copied, setCopied] = (0, $1oC0p.useState)(false);
    const onShare = (0, $1oC0p.useCallback)(async ()=>{
        const url = $0c13ec0efd8426d8$var$buildShareUrl((0, $kdccD.toQueryString)(query));
        try {
            await navigator.clipboard.writeText(url);
            setCopied(true);
            setTimeout(()=>setCopied(false), 2000);
        } catch  {
            // Clipboard may be unavailable (e.g. insecure context) — fall back.
            window.prompt('Copy this URL:', url);
        }
    }, [
        query
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
        variant: "primary",
        size: "small",
        onClick: onShare,
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
            style: {
                display: 'inline-flex',
                alignItems: 'center',
                gap: '8px'
            },
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($deg4B))), {
                    label: ""
                }),
                copied ? 'Link copied' : 'Copy URL to share'
            ]
        })
    });
};
const $0c13ec0efd8426d8$var$buildShareUrl = (queryString)=>{
    const { origin: origin, pathname: pathname } = window.location;
    return `${origin}${pathname}${queryString ? `?${queryString}` : ''}`;
};

});


parcelRegister("8wHAz", function(module, exports) {
$parcel$export(module.exports, "EstimateDisclaimer", function () { return $0ecad20c385e021a$export$e962f554efad26d8; });

var $7VQPk = parcelRequire("7VQPk");

var $kbpa7 = parcelRequire("kbpa7");
const $0ecad20c385e021a$export$e962f554efad26d8 = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        style: $0ecad20c385e021a$var$wrapperStyle,
        "data-testid": "estimate-disclaimer",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            style: $0ecad20c385e021a$var$copyStyle,
            children: "This estimate isn\u2019t binding for either you or Atlassian. Figures shown here are intended to show an estimation of usage allowance, and may be subject to change."
        })
    });
// Full-width centering wrapper with 20px top padding (the gap from the
// Copy URL to share row above per Figma node 1103:32365).
const $0ecad20c385e021a$var$wrapperStyle = {
    display: 'flex',
    justifyContent: 'center',
    paddingBlockStart: '20px'
};
// Fine-print typography — Charlie Text Regular 12/18, primary-black,
// center-aligned, max-width 768px so the line-length stays comfortable
// regardless of container width.
const $0ecad20c385e021a$var$copyStyle = {
    margin: 0,
    fontFamily: (0, $kbpa7.wacToken)('font.charlie.text'),
    fontSize: '12px',
    lineHeight: '18px',
    fontWeight: 400,
    color: (0, $kbpa7.wacToken)('color.neutral.light1100'),
    textAlign: 'center',
    maxWidth: '768px'
};

});

parcelRegister("iZlze", function(module, exports) {
$parcel$export(module.exports, "FeedbackButtons", function () { return $f575de999ccb7f41$export$c633fc044a8b8981; });
/* feedback-buttons.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $eGGys = parcelRequire("eGGys");

var $82rWc = parcelRequire("82rWc");

var $kbpa7 = parcelRequire("kbpa7");

var $hciAo = parcelRequire("hciAo");
const $f575de999ccb7f41$export$c633fc044a8b8981 = ({ vote: vote, onVote: onVote, label: label, testId: testId = 'ubp-feedback-buttons' })=>{
    const intl = (0, $8e22h.default)();
    const hasVoted = vote !== null;
    const handleClick = (nextVote)=>{
        // Guard against repeat votes — parent may still choose to allow them
        // by resetting `vote` back to null between clicks, but the default
        // behavior is single-vote.
        if (hasVoted) return;
        onVote(nextVote);
    };
    const resolvedLabel = label ?? intl.formatMessage((0, $hciAo.messages).label);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        "data-testid": testId,
        className: (0, $2jatx.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _zulpgktf _ect4z4z1"
        ]),
        style: {
            "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text'))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_ect4z4z1 _1wyb7vkz _vwz41tcg _syaz1pfd _o5721q9c _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                ]),
                style: {
                    "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text')),
                    "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
                },
                children: resolvedLabel
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _4cvr1h6o _zulpftgi"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                        type: "button",
                        onClick: ()=>handleClick('up'),
                        "aria-label": intl.formatMessage((0, $hciAo.messages).thumbsUpAriaLabel),
                        "aria-pressed": vote === 'up',
                        "aria-disabled": hasVoted,
                        disabled: hasVoted,
                        "data-testid": `${testId}-thumbs-up`,
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _4cvr1h6o _1bah1h6o _11q7glyw _19it79pa _ca0q1crf _u5f31crf _n3td1crf _19bv1crf _80omtlke _2rkoftgi _syaz1pfd _v564cklq _16l415iw _1ygb1qgu _1ah3yh40 _j5dh1wug _1ldbkb7n",
                            vote === 'up' && "_syaz5hrz"
                        ]),
                        style: {
                            "--_1tiihzy": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light600')),
                            "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                            "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
                        },
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($82rWc))), {
                            label: ""
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                        type: "button",
                        onClick: ()=>handleClick('down'),
                        "aria-label": intl.formatMessage((0, $hciAo.messages).thumbsDownAriaLabel),
                        "aria-pressed": vote === 'down',
                        "aria-disabled": hasVoted,
                        disabled: hasVoted,
                        "data-testid": `${testId}-thumbs-down`,
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _4cvr1h6o _1bah1h6o _11q7glyw _19it79pa _ca0q1crf _u5f31crf _n3td1crf _19bv1crf _80omtlke _2rkoftgi _syaz1pfd _v564cklq _16l415iw _1ygb1qgu _1ah3yh40 _j5dh1wug _1ldbkb7n",
                            vote === 'down' && "_syaz5hrz"
                        ]),
                        style: {
                            "--_1tiihzy": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light600')),
                            "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                            "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
                        },
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eGGys))), {
                            label: ""
                        })
                    })
                ]
            }),
            hasVoted ? /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                role: "status",
                className: (0, $2jatx.default)([
                    "_kqswstnw _1bsbt94y _4t3it94y _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pk1n1a _2hwx1n1a _otyr1n1a _18u01n1a _1reo15vq _18m915vq _ogtocqaw _o5721q9c _19itidpf"
                ]),
                children: intl.formatMessage((0, $hciAo.messages).thanksAfterVote)
            }) : null
        ]
    });
};
const $f575de999ccb7f41$var$containerStyles = null;
const $f575de999ccb7f41$var$labelStyles = null;
const $f575de999ccb7f41$var$buttonRowStyles = null;
const $f575de999ccb7f41$var$iconButtonStyles = null;
const $f575de999ccb7f41$var$iconButtonActiveStyles = null;
// Standard visually-hidden pattern — keeps the confirmation available to
// screen readers without occupying visual space or shifting the layout.
const $f575de999ccb7f41$var$visuallyHiddenStyles = null;

});
parcelRegister("hciAo", function(module, exports) {
$parcel$export(module.exports, "messages", function () { return $d5befc58923476ff$export$defe85febe8b728c; });

var $fnHPc = parcelRequire("fnHPc");
const $d5befc58923476ff$export$defe85febe8b728c = (0, $fnHPc.defineMessages)({
    label: {
        id: 'ubp.calculator.feedbackButtons.label',
        defaultMessage: 'Did you find this page helpful?'
    },
    thumbsUpAriaLabel: {
        id: 'ubp.calculator.feedbackButtons.thumbsUpAriaLabel',
        defaultMessage: 'Yes, this page was helpful'
    },
    thumbsDownAriaLabel: {
        id: 'ubp.calculator.feedbackButtons.thumbsDownAriaLabel',
        defaultMessage: 'No, this page was not helpful'
    },
    thanksAfterVote: {
        id: 'ubp.calculator.feedbackButtons.thanksAfterVote',
        defaultMessage: 'Thanks for your feedback!'
    }
});

});


parcelRegister("93kHd", function(module, exports) {
$parcel$export(module.exports, "ResultsCard", function () { return $1fe9b0855fddbdb4$export$eded4c54ca0c8242; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $5RBBI = parcelRequire("5RBBI");

var $kbpa7 = parcelRequire("kbpa7");

var $jsxHL = parcelRequire("jsxHL");
const $1fe9b0855fddbdb4$export$eded4c54ca0c8242 = ({ eyebrow: eyebrow, headline: headline, headlineSubtext: headlineSubtext, coverageText: coverageText, bullets: bullets, dropdown: dropdown, footerNote: footerNote, testId: testId = 'results-card' })=>{
    // Stable ID for the native select's aria-label / label-for pairing.
    const uid = (0, $1oC0p.useId)();
    const selectId = dropdown ? `${testId}-${uid}-select` : undefined;
    // Locally-typed bullets array — avoids a non-null assertion in the
    // JSX below and gives TypeScript a narrowed `string[]` inside the guard.
    const safeBullets = Array.isArray(bullets) && bullets.length > 0 ? bullets : [];
    const hasBullets = safeBullets.length > 0;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jsxHL.TypographyStyles), {
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            style: $1fe9b0855fddbdb4$var$cardStyle,
            "data-testid": testId,
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    style: $1fe9b0855fddbdb4$var$cardInnerStyle,
                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        style: $1fe9b0855fddbdb4$var$contentStyle,
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                style: $1fe9b0855fddbdb4$var$eyebrowStyle,
                                children: eyebrow
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                style: $1fe9b0855fddbdb4$var$recommendationStyle,
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                        style: $1fe9b0855fddbdb4$var$headlineStyle,
                                        children: headline
                                    }),
                                    headlineSubtext ? /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                        style: $1fe9b0855fddbdb4$var$headlineSubtextStyle,
                                        children: headlineSubtext
                                    }) : null
                                ]
                            }),
                            coverageText || hasBullets ? /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                style: $1fe9b0855fddbdb4$var$coverageStyle,
                                children: [
                                    coverageText ? /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                        style: $1fe9b0855fddbdb4$var$coverageTextStyle,
                                        children: coverageText
                                    }) : null,
                                    hasBullets ? /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
                                        style: $1fe9b0855fddbdb4$var$bulletListStyle,
                                        children: safeBullets.map((bullet, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                                                style: $1fe9b0855fddbdb4$var$bulletItemStyle,
                                                children: bullet
                                            }, `${bullet}-${index}`))
                                    }) : null
                                ]
                            }) : null,
                            dropdown ? /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                style: $1fe9b0855fddbdb4$var$dropdownWrapperStyle,
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("label", {
                                        htmlFor: selectId,
                                        style: $1fe9b0855fddbdb4$var$visuallyHiddenStyle,
                                        children: dropdown.ariaLabel
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                        style: $1fe9b0855fddbdb4$var$dropdownPillStyle,
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsxs)("select", {
                                                id: selectId,
                                                value: dropdown.value,
                                                onChange: (e)=>dropdown.onChange(e.target.value),
                                                style: $1fe9b0855fddbdb4$var$selectStyle,
                                                "data-testid": `${testId}-select`,
                                                children: [
                                                    dropdown.placeholder ? /*#__PURE__*/ (0, $7VQPk.jsx)("option", {
                                                        value: "",
                                                        disabled: true,
                                                        children: dropdown.placeholder
                                                    }) : null,
                                                    dropdown.options.map((opt)=>/*#__PURE__*/ (0, $7VQPk.jsx)("option", {
                                                            value: opt.value,
                                                            children: opt.label
                                                        }, opt.value))
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                                style: $1fe9b0855fddbdb4$var$chevronStyle,
                                                "aria-hidden": "true",
                                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5RBBI))), {
                                                    label: ""
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }) : null
                        ]
                    })
                }),
                footerNote ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    style: $1fe9b0855fddbdb4$var$footerStyle,
                    "data-testid": `${testId}-footer`,
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        style: $1fe9b0855fddbdb4$var$footerTextStyle,
                        children: footerNote
                    })
                }) : null
            ]
        })
    });
};
// ─────────────────────────────────────────────────────────────────────────
// Styles — matching Figma tokens from node 642:6143.
// The card lives in the calculator's estimate/summary steps; keep all
// styling colocated so future designers can eyeball it in one place.
// ─────────────────────────────────────────────────────────────────────────
const $1fe9b0855fddbdb4$var$cardStyle = {
    // Figma: neutral/opaque/neutral100 (#F8F8F8), 20px rounded corners,
    // no border, overflow hidden (so the blue footer clips its top corners
    // against the rounded card).
    backgroundColor: (0, $kbpa7.wacToken)('color.neutral.light100'),
    borderRadius: '20px',
    overflow: 'hidden',
    // Column flex so the value-add footer sits flush against the bottom.
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    width: '100%'
};
const $1fe9b0855fddbdb4$var$cardInnerStyle = {
    // Figma padding: 20px sides, 20px top, 32px bottom.
    padding: '20px 20px 32px 20px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    width: '100%',
    boxSizing: 'border-box'
};
const $1fe9b0855fddbdb4$var$contentStyle = {
    // Figma gap: space/300 (24px) between eyebrow / recommendation /
    // coverage / dropdown sections.
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    alignItems: 'stretch'
};
const $1fe9b0855fddbdb4$var$eyebrowStyle = {
    // Figma "More Styles / Eyebrow - Regular": 14/18 Charlie Text Regular,
    // uppercase, Primary Black at 80% opacity.
    fontFamily: (0, $kbpa7.wacToken)('font.charlie.text'),
    fontSize: '14px',
    lineHeight: '18px',
    fontWeight: 400,
    letterSpacing: 0,
    textTransform: 'uppercase',
    // Figma spec uses `rgba(0,0,0,0.8)`. WAC's design system has no
    // opacity-adjusted token that matches exactly; using the solid Primary
    // Black (`color.neutral.light1100` = #101214) provides equivalent
    // contrast and stays token-compliant.
    color: (0, $kbpa7.wacToken)('color.neutral.light1100')
};
const $1fe9b0855fddbdb4$var$recommendationStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: '0px',
    alignItems: 'stretch'
};
const $1fe9b0855fddbdb4$var$headlineStyle = {
    // Figma "Desktop / D - H3": 32/38 Charlie Display Bold, tracking 0.3px.
    margin: 0,
    fontFamily: (0, $kbpa7.wacToken)('font.charlie.display'),
    fontSize: '32px',
    lineHeight: '38px',
    fontWeight: 700,
    letterSpacing: '0.3px',
    color: (0, $kbpa7.wacToken)('color.neutral.light1100')
};
const $1fe9b0855fddbdb4$var$headlineSubtextStyle = {
    // Figma "Desktop / D - Body Medium": 16/24 Charlie Text Regular.
    margin: 0,
    fontFamily: (0, $kbpa7.wacToken)('font.charlie.text'),
    fontSize: '16px',
    lineHeight: '24px',
    fontWeight: 400,
    color: (0, $kbpa7.wacToken)('color.neutral.light1100')
};
const $1fe9b0855fddbdb4$var$coverageStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    alignItems: 'stretch'
};
const $1fe9b0855fddbdb4$var$coverageTextStyle = {
    // Figma "Desktop / D - Body Medium - Bold": 16/24 Charlie Text Bold.
    margin: 0,
    fontFamily: (0, $kbpa7.wacToken)('font.charlie.text'),
    fontSize: '16px',
    lineHeight: '24px',
    fontWeight: 700,
    color: (0, $kbpa7.wacToken)('color.neutral.light1100')
};
const $1fe9b0855fddbdb4$var$bulletListStyle = {
    margin: 0,
    // 21px left indent from Figma matches the ContentBlock bullet spec.
    paddingInlineStart: '21px',
    fontFamily: (0, $kbpa7.wacToken)('font.charlie.text'),
    fontSize: '14px',
    lineHeight: '20px',
    fontWeight: 400,
    color: (0, $kbpa7.wacToken)('color.neutral.light1100'),
    listStyle: 'disc'
};
const $1fe9b0855fddbdb4$var$bulletItemStyle = {
    // Figma: 8px between bullets. Last-child handled by natural absence of margin.
    marginBottom: '8px'
};
const $1fe9b0855fddbdb4$var$dropdownWrapperStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start'
};
const $1fe9b0855fddbdb4$var$dropdownPillStyle = {
    // Figma "Selector": white bg, 1px #7D818A border, 20px pill, 8/16 padding.
    // Min-width 202px, max-width 368px per Figma constraints.
    position: 'relative',
    display: 'inline-flex',
    alignItems: 'center',
    backgroundColor: (0, $kbpa7.wacToken)('color.neutral.light0'),
    border: `1px solid ${(0, $kbpa7.wacToken)('color.neutral.light600')}`,
    borderRadius: '20px',
    minWidth: '202px',
    maxWidth: '368px',
    width: '100%',
    boxSizing: 'border-box'
};
const $1fe9b0855fddbdb4$var$selectStyle = {
    // Reset native <select> styling; the wrapping pill provides the visual
    // affordance. `appearance: none` removes the browser chevron so our
    // decorative one is the only chevron visible.
    appearance: 'none',
    WebkitAppearance: 'none',
    MozAppearance: 'none',
    flex: 1,
    padding: '8px 40px 8px 16px',
    // right padding leaves room for chevron
    border: 'none',
    outline: 'none',
    background: 'transparent',
    fontFamily: (0, $kbpa7.wacToken)('font.charlie.text'),
    fontSize: '16px',
    lineHeight: '24px',
    color: (0, $kbpa7.wacToken)('color.neutral.light1100'),
    cursor: 'pointer'
};
const $1fe9b0855fddbdb4$var$chevronStyle = {
    position: 'absolute',
    right: '16px',
    top: '50%',
    transform: 'translateY(-50%)',
    display: 'inline-flex',
    alignItems: 'center',
    pointerEvents: 'none',
    color: (0, $kbpa7.wacToken)('color.neutral.light1100')
};
const $1fe9b0855fddbdb4$var$footerStyle = {
    // Figma "value add": Extended/Blues/B100 (#E9F2FE) bg, 12px padding.
    backgroundColor: (0, $kbpa7.wacToken)('color.extended.blue100'),
    padding: '12px',
    display: 'flex',
    alignItems: 'flex-start'
};
const $1fe9b0855fddbdb4$var$footerTextStyle = {
    margin: 0,
    flex: 1,
    fontFamily: (0, $kbpa7.wacToken)('font.charlie.text'),
    fontSize: '16px',
    lineHeight: '24px',
    fontWeight: 400,
    color: (0, $kbpa7.wacToken)('color.neutral.light1100')
};
const $1fe9b0855fddbdb4$var$visuallyHiddenStyle = {
    position: 'absolute',
    width: '1px',
    height: '1px',
    padding: 0,
    margin: '-1px',
    overflow: 'hidden',
    clip: 'rect(0, 0, 0, 0)',
    whiteSpace: 'nowrap',
    border: 0
};

});

parcelRegister("f1WTS", function(module, exports) {
$parcel$export(module.exports, "METER_LABELS", function () { return $f9a8942f61abe515$export$7c4ca1fa5918a98; });
const $f9a8942f61abe515$export$7c4ca1fa5918a98 = {
    rovoCredits: 'Rovo Credits',
    automations: 'Automations',
    csResolutions: 'CS Resolutions',
    assetsObjects: 'Assets Objects'
};
const $f9a8942f61abe515$export$c86caf1be068fb8d = (price, options)=>{
    const { currency: currency, locale: locale, fractionDigits: fractionDigits = 0 } = options;
    return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits
    }).format(price);
};

});


parcelRegister("dEuk8", function(module, exports) {
$parcel$export(module.exports, "NeedsStep", function () { return $d8baf1a85e15b192$export$e20aa7cd146c54c8; });
/* needs-step.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $kbpa7 = parcelRequire("kbpa7");

var $jsxHL = parcelRequire("jsxHL");

var $4xsw0 = parcelRequire("4xsw0");

var $hSUNh = parcelRequire("hSUNh");

var $ahF4L = parcelRequire("ahF4L");

var $ehiBJ = parcelRequire("ehiBJ");

var $cIZNT = parcelRequire("cIZNT");

var $f1WTS = parcelRequire("f1WTS");
const $d8baf1a85e15b192$export$e20aa7cd146c54c8 = ()=>{
    const intl = (0, $8e22h.default)();
    const usageType = (0, $4xsw0.useSelector)((0, $hSUNh.selectUsageType));
    const setUsageType = (0, $4xsw0.useSetUsageType)();
    const meter = (0, $4xsw0.useSelector)((0, $hSUNh.selectMeter));
    const usage = (0, $4xsw0.useSelector)((0, $hSUNh.selectUsage));
    const setUsage = (0, $4xsw0.useSetUsage)();
    const [usageInput, setUsageInput] = (0, $1oC0p.useState)(String(usage));
    const NEEDS_STRINGS = (0, $1oC0p.useMemo)(()=>({
            exploring: {
                label: 'Exploring',
                description: intl.formatMessage({
                    id: 'ubp.calculator.needs.exploring.description',
                    defaultMessage: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent vitae.'
                }),
                info: intl.formatMessage({
                    id: 'ubp.calculator.needs.exploring.info',
                    defaultMessage: 'Teams in pilot typically save 2-3 hours per person per week before any broad rollout'
                }),
                list: [
                    {
                        text: intl.formatMessage({
                            id: 'ubp.calculator.needs.exploring.list.rovoChat',
                            defaultMessage: '200 Rovo Chat conversations'
                        })
                    },
                    {
                        text: intl.formatMessage({
                            id: 'ubp.calculator.needs.exploring.list.agentRuns',
                            defaultMessage: '2-3 agent runs'
                        })
                    },
                    {
                        text: intl.formatMessage({
                            id: 'ubp.calculator.needs.exploring.list.customAgents',
                            defaultMessage: "1\u20132 custom agents"
                        })
                    }
                ]
            },
            adopting: {
                label: 'Adopting',
                description: intl.formatMessage({
                    id: 'ubp.calculator.needs.adopting.description',
                    defaultMessage: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer nec odio.'
                }),
                info: intl.formatMessage({
                    id: 'ubp.calculator.needs.adopting.info',
                    defaultMessage: 'Customers report up to 40% faster issue resolution when Rovo handles routine queries day-to-day.'
                }),
                list: [
                    {
                        text: intl.formatMessage({
                            id: 'ubp.calculator.needs.adopting.list.rovoChat',
                            defaultMessage: '200 Rovo Chat conversations'
                        })
                    },
                    {
                        text: intl.formatMessage({
                            id: 'ubp.calculator.needs.adopting.list.agentRuns',
                            defaultMessage: '2-3 agent runs'
                        })
                    },
                    {
                        text: intl.formatMessage({
                            id: 'ubp.calculator.needs.adopting.list.customAgents',
                            defaultMessage: "1\u20132 custom agents"
                        })
                    }
                ]
            },
            scaling: {
                label: 'Scaling',
                description: intl.formatMessage({
                    id: 'ubp.calculator.needs.scaling.description',
                    defaultMessage: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor.'
                }),
                info: intl.formatMessage({
                    id: 'ubp.calculator.needs.scaling.info',
                    defaultMessage: 'Teams in pilot typically save 2-3 hours per person per week before any broad rollout'
                }),
                list: [
                    {
                        text: intl.formatMessage({
                            id: 'ubp.calculator.needs.scaling.list.rovoChat',
                            defaultMessage: '200 Rovo Chat conversations'
                        })
                    },
                    {
                        text: intl.formatMessage({
                            id: 'ubp.calculator.needs.scaling.list.agentRuns',
                            defaultMessage: '2-3 agent runs'
                        })
                    },
                    {
                        text: intl.formatMessage({
                            id: 'ubp.calculator.needs.scaling.list.customAgents',
                            defaultMessage: "1\u20132 custom agents"
                        })
                    }
                ]
            }
        }), [
        intl
    ]);
    const needsTypes = Object.keys(NEEDS_STRINGS);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $jsxHL.TypographyStyles), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cIZNT.Stepper), {}),
            /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                className: (0, $2jatx.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1q511ylp"
                ]),
                children: intl.formatMessage({
                    id: 'ubp.calculator.needs.pageTitle',
                    defaultMessage: 'Tell us about your team\u2019s usage'
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                id: "needs-step-heading",
                className: (0, $2jatx.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1q51u2gc _85i51ylp _1wyb1k92 _vwz41m1q _k48p1nn1 _syazrf0c"
                ]),
                style: {
                    "--_ve8pbe": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light1100'))
                },
                children: intl.formatMessage({
                    id: 'ubp.calculator.needs.pageSubtitle',
                    defaultMessage: 'Choose an option that best describes how your team will use {meterLabel} each month'
                }, {
                    meterLabel: (0, $f1WTS.METER_LABELS)[meter]
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                role: "radiogroup",
                "aria-labelledby": "needs-step-heading",
                className: (0, $2jatx.default)([
                    "_1e0c11p5 _zulpxy5q _yv0e1ckl _1ph4wxkt _19d7hkll"
                ]),
                children: needsTypes.map((choice)=>{
                    const { label: label, description: description, list: list, info: info } = NEEDS_STRINGS[choice];
                    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ahF4L.ChoiceCard), {
                        value: choice,
                        selected: usageType === choice,
                        onSelect: ()=>setUsageType(choice),
                        groupName: "group-needs",
                        label: label,
                        description: description,
                        list: list,
                        info: info
                    }, `needs-${choice}`);
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx2vrvc _4cvr1h6o _zulppxbi _1n261g80 _1q511wqb"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                        id: "usage-label",
                        className: (0, $2jatx.default)([
                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("label", {
                            htmlFor: "usage",
                            children: intl.formatMessage({
                                id: 'ubp.calculator.needs.usageQuestion',
                                defaultMessage: 'Do you know your usage?'
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _4cvr1h6o _zulppxbi"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("input", {
                                id: "usage",
                                type: "number",
                                value: usageInput,
                                min: 0,
                                "aria-labelledby": "usage-label",
                                placeholder: `Current ${(0, $f1WTS.METER_LABELS)[meter]} usage`,
                                onChange: (e)=>{
                                    const next = e.target.value;
                                    setUsageInput(next);
                                    setUsage(next === '' ? 0 : Number(next));
                                },
                                className: (0, $2jatx.default)([
                                    "_1bsb1lit _4t3i1ylp _1rjcu2gc _18zrpxbi _1wyb1j6v _vwz41tcg _19it79pa _2rkogktf _bfhk1afi _syazrf0c"
                                ]),
                                style: {
                                    "--_1tiihzy": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light600')),
                                    "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
                                    "--_ve8pbe": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light1100'))
                                }
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                className: (0, $2jatx.default)([
                                    "_1wyboxwj _vwz4gktf _syazrf0c"
                                ]),
                                style: {
                                    "--_ve8pbe": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light1100'))
                                },
                                children: intl.formatMessage({
                                    id: 'ubp.calculator.needs.optional',
                                    defaultMessage: 'Optional'
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ehiBJ.StepNav), {
                showBack: true,
                showNext: true,
                nextLabel: "Get estimate"
            })
        ]
    });
};
// Page title — rendered as an H3 (Charlie Display Bold 32/38 via
// TypographyStyles). Left-aligned per Figma; 40px top padding keeps the title
// spaced from the Stepper, and the subtitle below owns the bottom spacing so
// the title + subtitle stay visually grouped.
const $d8baf1a85e15b192$var$pageTitleStyle = null;
// Body Large subtitle beneath the H3 title. Charlie Text 20/28 with the
// standard neutral text color. Sits directly under the title with a small gap
// above (space.100) and 40px padding below to separate the title/subtitle
// pair from the choice-card grid. The visible copy dynamically references the
// meter chosen in the previous step (e.g. "Rovo Credits", "Automations", "CS
// Resolutions", "Assets Objects") via ICU `{meterLabel}` interpolation.
const $d8baf1a85e15b192$var$pageSubtitleStyle = null;
const $d8baf1a85e15b192$var$cardGridStyle = null;
// Wraps the usage-question H3 and the input + "Optional" indicator so they sit
// on the same row — mirrors usage-step.tsx's orgSizeQuestionStyle so both steps
// share the same input row treatment. 60px top padding lives on the row
// wrapper so both sides shift together and stay vertically aligned.
const $d8baf1a85e15b192$var$usageQuestionStyle = null;
const $d8baf1a85e15b192$var$usageQuestionHeadingStyle = null;
// Places the number input and the "Optional" indicator side-by-side, with the
// label vertically centered on the input.
const $d8baf1a85e15b192$var$inputAndOptionalStyle = null;
const $d8baf1a85e15b192$var$numberInputStyle = null;
const $d8baf1a85e15b192$var$optionalLabelStyle = null;

});

parcelRegister("jESEJ", function(module, exports) {
$parcel$export(module.exports, "SummaryStep", function () { return $add1ab1e0ec10174$export$a9efd057ccbc1d85; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $iPPTB = parcelRequire("iPPTB");

var $kbpa7 = parcelRequire("kbpa7");

var $jsxHL = parcelRequire("jsxHL");

var $73KXs = parcelRequire("73KXs");

var $4xsw0 = parcelRequire("4xsw0");

var $hSUNh = parcelRequire("hSUNh");

var $kdccD = parcelRequire("kdccD");

var $8wHAz = parcelRequire("8wHAz");

var $9wpUt = parcelRequire("9wpUt");

var $iZlze = parcelRequire("iZlze");

var $93kHd = parcelRequire("93kHd");

var $f8Axo = parcelRequire("f8Axo");

var $cIZNT = parcelRequire("cIZNT");

var $f1WTS = parcelRequire("f1WTS");
const $add1ab1e0ec10174$export$a9efd057ccbc1d85 = ()=>{
    const meter = (0, $4xsw0.useSelector)((0, $hSUNh.selectMeter));
    const meterLower = (0, $9wpUt.METER_LABELS_LOWER)[meter];
    const goToPrev = (0, $4xsw0.useGoToPrevStep)();
    // Feedback vote is component-local for now — mirrors the Estimate
    // step's treatment. A follow-up ticket will wire this into analytics
    // and persist the preference.
    const [vote, setVote] = (0, $1oC0p.useState)(null);
    // Build a real, valid href for the Back link that points at the same
    // calculator URL with `step` set to the previous step. Enables the
    // anchor to be bookmarkable / right-clickable / openable in a new
    // tab. The inline onClick prevents the full page reload and drives
    // the calculator state machine instead.
    const shareableQuery = (0, $4xsw0.useSelector)((0, $hSUNh.selectShareableQuery));
    const currentStep = (0, $4xsw0.useSelector)((ctx)=>ctx.step);
    const prevStep = (0, $73KXs.STEP_ORDER)[(0, $73KXs.STEP_ORDER).indexOf(currentStep) - 1];
    const prevStepHref = prevStep ? `?${(0, $kdccD.toQueryString)({
        ...shareableQuery,
        step: prevStep
    })}` : '?';
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cIZNT.Stepper), {}),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jsxHL.TypographyStyles), {
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    style: $add1ab1e0ec10174$var$pageHeaderStyle,
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                            style: $add1ab1e0ec10174$var$pageTitleStyle,
                            children: "Review usage estimate and compare"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("p", {
                            style: $add1ab1e0ec10174$var$pageSubtitleStyle,
                            children: [
                                "Based on what you\u2019ve told us, here\u2019s a summary of how many ",
                                meterLower,
                                " you need, and how you can use them."
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                style: $add1ab1e0ec10174$var$twoColumnRowStyle,
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        style: $add1ab1e0ec10174$var$leftColumnStyle,
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)($add1ab1e0ec10174$var$OrgNeedsResultsCard, {}),
                            /*#__PURE__*/ (0, $7VQPk.jsx)($add1ab1e0ec10174$var$CoveredResultsCard, {}),
                            /*#__PURE__*/ (0, $7VQPk.jsx)($add1ab1e0ec10174$var$HowYourTeamsMightUse, {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        style: $add1ab1e0ec10174$var$rightColumnStyle,
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)($add1ab1e0ec10174$var$PriceCardPlaceholder, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                style: $add1ab1e0ec10174$var$feedbackWrapperStyle,
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iZlze.FeedbackButtons), {
                    vote: vote,
                    onVote: setVote
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                style: $add1ab1e0ec10174$var$bottomActionRowStyle,
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                        type: "primary",
                        size: "md",
                        text: "Back",
                        ariaLabel: "Back",
                        href: prevStepHref,
                        onClick: (e)=>{
                            e.preventDefault();
                            goToPrev();
                        },
                        showArrow: false,
                        showUnderline: false
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $f8Axo.ShareButton), {})
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8wHAz.EstimateDisclaimer), {})
        ]
    });
};
// ─────────────────────────────────────────────────────────────────────────
// Left-column: ResultsCard for "Your organization needs"
// ─────────────────────────────────────────────────────────────────────────
const $add1ab1e0ec10174$var$OrgNeedsResultsCard = ()=>{
    const meter = (0, $4xsw0.useSelector)((0, $hSUNh.selectMeter));
    const { low: low, high: high } = (0, $4xsw0.useSelector)((0, $hSUNh.selectEstimatedUsageRange));
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $93kHd.ResultsCard), {
        eyebrow: "YOUR ORGANIZATION NEEDS",
        headline: `${low.toLocaleString('en-US')}\u{2013}${high.toLocaleString('en-US')}`,
        headlineSubtext: `${(0, $f1WTS.METER_LABELS)[meter]} per month`,
        testId: "summary-org-needs"
    });
};
// ─────────────────────────────────────────────────────────────────────────
// Left-column: ResultsCard for "What's covered"
// ─────────────────────────────────────────────────────────────────────────
const $add1ab1e0ec10174$var$CoveredResultsCard = ()=>{
    const meter = (0, $4xsw0.useSelector)((0, $hSUNh.selectMeter));
    const included = (0, $4xsw0.useSelector)((0, $hSUNh.selectIncludedAllowance));
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $93kHd.ResultsCard), {
        eyebrow: "WHAT'S COVERED",
        headline: included.toLocaleString('en-US'),
        headlineSubtext: `${(0, $f1WTS.METER_LABELS)[meter]} included, monthly`,
        testId: "summary-covered"
    });
};
// ─────────────────────────────────────────────────────────────────────────
// Left-column: "How your teams might use" — value cards WITHOUT icons
// ─────────────────────────────────────────────────────────────────────────
const $add1ab1e0ec10174$var$HowYourTeamsMightUse = ()=>{
    const meter = (0, $4xsw0.useSelector)((0, $hSUNh.selectMeter));
    const meterLower = (0, $9wpUt.METER_LABELS_LOWER)[meter];
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        style: $add1ab1e0ec10174$var$valueCardsPanelStyle,
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("p", {
                style: $add1ab1e0ec10174$var$valueCardsEyebrowStyle,
                children: [
                    "How your teams might use ",
                    meterLower
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                style: $add1ab1e0ec10174$var$valuePropStackStyle,
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        style: $add1ab1e0ec10174$var$valuePropItemStyle,
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                style: $add1ab1e0ec10174$var$valuePropTitleStyle,
                                children: "Maximize your ROI"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("p", {
                                style: $add1ab1e0ec10174$var$valuePropDescriptionStyle,
                                children: [
                                    "Value prop 1 for ",
                                    meterLower,
                                    ". Description of how this benefit applies to your team\u2019s usage."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        style: $add1ab1e0ec10174$var$valuePropItemStyle,
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                style: $add1ab1e0ec10174$var$valuePropTitleStyle,
                                children: "Plan with confidence"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("p", {
                                style: $add1ab1e0ec10174$var$valuePropDescriptionStyle,
                                children: [
                                    "Value prop 2 for ",
                                    meterLower,
                                    ". Description of how this benefit applies to your team\u2019s usage."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        style: $add1ab1e0ec10174$var$valuePropItemStyle,
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                style: $add1ab1e0ec10174$var$valuePropTitleStyle,
                                children: "Unlock more with less"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("p", {
                                style: $add1ab1e0ec10174$var$valuePropDescriptionStyle,
                                children: [
                                    "Value prop 3 for ",
                                    meterLower,
                                    ". Description of how this benefit applies to your team\u2019s usage."
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
// ─────────────────────────────────────────────────────────────────────────
// Right-column: Price / Product card placeholder (GWP-12557)
// ─────────────────────────────────────────────────────────────────────────
const $add1ab1e0ec10174$var$PriceCardPlaceholder = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        style: $add1ab1e0ec10174$var$placeholderCardStyle,
        "data-testid": "summary-price-card-placeholder",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                style: $add1ab1e0ec10174$var$placeholderLabelStyle,
                children: "Price / Product Card"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                style: $add1ab1e0ec10174$var$placeholderNoteStyle,
                children: "Placeholder \u2014 see GWP-12557"
            })
        ]
    });
// ─────────────────────────────────────────────────────────────────────────
// Styles
// ─────────────────────────────────────────────────────────────────────────
// Header per Figma node 1103:32406 — 80px above the H3 (40px base + 40
// added per design refinement) and 40px below the subtitle.
const $add1ab1e0ec10174$var$pageHeaderStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    paddingBlockStart: '80px',
    paddingBlockEnd: '40px'
};
const $add1ab1e0ec10174$var$pageTitleStyle = {
    // TypographyStyles maps raw `h3` to Charlie Display Bold 32/38.
    margin: 0
};
const $add1ab1e0ec10174$var$pageSubtitleStyle = {
    // Body Large: Charlie Text Regular 20/28.
    margin: 0,
    fontSize: '20px',
    lineHeight: '28px',
    fontWeight: 400,
    color: (0, $kbpa7.wacToken)('color.neutral.light1100')
};
// Two-column layout — collapses to single column below ~832px via
// `repeat(auto-fit, minmax(400px, 1fr))`. Matches Estimate step.
const $add1ab1e0ec10174$var$twoColumnRowStyle = {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))',
    gap: '32px',
    alignItems: 'start'
};
const $add1ab1e0ec10174$var$leftColumnStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px'
};
const $add1ab1e0ec10174$var$rightColumnStyle = {
    display: 'flex',
    flexDirection: 'column'
};
// Value cards panel (mirrors Estimate step's HowYourTeamsMightUse).
const $add1ab1e0ec10174$var$valueCardsPanelStyle = {
    backgroundColor: (0, $kbpa7.wacToken)('color.neutral.light100'),
    borderRadius: '20px',
    padding: '20px 20px 32px 20px',
    display: 'flex',
    flexDirection: 'column',
    gap: '24px'
};
const $add1ab1e0ec10174$var$valueCardsEyebrowStyle = {
    margin: 0,
    fontFamily: (0, $kbpa7.wacToken)('font.charlie.text'),
    fontSize: '14px',
    lineHeight: '18px',
    fontWeight: 400,
    textTransform: 'uppercase',
    letterSpacing: 0,
    color: (0, $kbpa7.wacToken)('color.neutral.light1100')
};
const $add1ab1e0ec10174$var$valuePropStackStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px'
};
const $add1ab1e0ec10174$var$valuePropItemStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: 0
};
const $add1ab1e0ec10174$var$valuePropTitleStyle = {
    margin: 0,
    fontFamily: (0, $kbpa7.wacToken)('font.charlie.text'),
    fontSize: '16px',
    lineHeight: '24px',
    fontWeight: 700,
    color: (0, $kbpa7.wacToken)('color.neutral.light1100')
};
const $add1ab1e0ec10174$var$valuePropDescriptionStyle = {
    margin: 0,
    fontFamily: (0, $kbpa7.wacToken)('font.charlie.text'),
    fontSize: '16px',
    lineHeight: '24px',
    fontWeight: 400,
    color: (0, $kbpa7.wacToken)('color.neutral.light1100')
};
// Price / Product card placeholder — dashed border, centered content.
const $add1ab1e0ec10174$var$placeholderCardStyle = {
    padding: '40px 24px',
    borderRadius: '20px',
    border: `2px dashed ${(0, $kbpa7.wacToken)('color.neutral.light400')}`,
    backgroundColor: (0, $kbpa7.wacToken)('color.neutral.light100'),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    minHeight: '320px',
    textAlign: 'center'
};
const $add1ab1e0ec10174$var$placeholderLabelStyle = {
    margin: 0,
    fontFamily: (0, $kbpa7.wacToken)('font.charlie.display'),
    fontSize: '24px',
    lineHeight: '30px',
    fontWeight: 700,
    color: (0, $kbpa7.wacToken)('color.neutral.light1100')
};
const $add1ab1e0ec10174$var$placeholderNoteStyle = {
    margin: 0,
    fontFamily: (0, $kbpa7.wacToken)('font.charlie.text'),
    fontSize: '14px',
    lineHeight: '20px',
    color: (0, $kbpa7.wacToken)('color.neutral.light800')
};
// Feedback wrapper — mirrors Estimate step (56px above, 44px below,
// horizontally centered).
const $add1ab1e0ec10174$var$feedbackWrapperStyle = {
    display: 'flex',
    justifyContent: 'center',
    paddingBlockStart: '56px',
    paddingBlockEnd: '44px'
};
// Bottom action row — Back link + Share button, side-by-side,
// vertically centered. Mirrors Estimate step's `bottomActionRowStyle`.
const $add1ab1e0ec10174$var$bottomActionRowStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '12px'
};

});

parcelRegister("hz9o6", function(module, exports) {
$parcel$export(module.exports, "UsageStep", function () { return $b7809bb0a68c6442$export$cc212cd84b434059; });
/* usage-step.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $kbpa7 = parcelRequire("kbpa7");

var $jsxHL = parcelRequire("jsxHL");

var $4xsw0 = parcelRequire("4xsw0");

var $hSUNh = parcelRequire("hSUNh");

var $ahF4L = parcelRequire("ahF4L");

var $ehiBJ = parcelRequire("ehiBJ");

var $cIZNT = parcelRequire("cIZNT");
const $b7809bb0a68c6442$export$cc212cd84b434059 = ()=>{
    const intl = (0, $8e22h.default)();
    const meter = (0, $4xsw0.useSelector)((0, $hSUNh.selectMeter));
    const setMeter = (0, $4xsw0.useSetMeter)();
    const orgUserCount = (0, $4xsw0.useSelector)((0, $hSUNh.selectOrgUserCount));
    const setOrgUserCount = (0, $4xsw0.useSetOrgUserCount)();
    const orgUserCountError = (0, $4xsw0.useOrgUserCountErrorMessage)();
    const canAdvance = (0, $4xsw0.useSelector)((0, $hSUNh.selectCanAdvanceUsageStep));
    const [orgUserCountInput, setOrgUserCountInput] = (0, $1oC0p.useState)(orgUserCount === undefined ? '' : String(orgUserCount));
    const USAGE_STRINGS = (0, $1oC0p.useMemo)(()=>({
            rovoCredits: {
                label: 'Rovo Credits',
                description: intl.formatMessage({
                    id: 'ubp.calculator.usage.rovoCredits.description',
                    defaultMessage: 'Use Rovo Search to find information, Rovo chat for insights, and Rovo agents to automate workflows.'
                })
            },
            automations: {
                label: 'Automations',
                description: intl.formatMessage({
                    id: 'ubp.calculator.usage.automations.description',
                    defaultMessage: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.'
                })
            },
            csResolutions: {
                label: 'CS Resolutions',
                description: intl.formatMessage({
                    id: 'ubp.calculator.usage.csResolutions.description',
                    defaultMessage: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.'
                })
            },
            assetsObjects: {
                label: 'Assets Objects',
                description: intl.formatMessage({
                    id: 'ubp.calculator.usage.assetsObjects.description',
                    defaultMessage: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.'
                })
            }
        }), [
        intl
    ]);
    const usageMeters = Object.keys(USAGE_STRINGS);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $jsxHL.TypographyStyles), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cIZNT.Stepper), {}),
            /*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
                className: (0, $2jatx.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o _1rjc1ylp"
                ]),
                children: intl.formatMessage({
                    id: 'ubp.calculator.usage.pageTitle',
                    defaultMessage: 'Let\u2019s figure out your usage needs'
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                id: "usage-step-heading",
                className: (0, $2jatx.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _85i51ylp"
                ]),
                children: intl.formatMessage({
                    id: 'ubp.calculator.usage.interestQuestion',
                    defaultMessage: 'What are you interested in?'
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                role: "radiogroup",
                "aria-labelledby": "usage-step-heading",
                className: (0, $2jatx.default)([
                    "_1e0c11p5 _zulpxy5q _yv0ewxkt _19d7hkll"
                ]),
                children: usageMeters.map((choice)=>{
                    const { label: label, description: description, list: list, info: info } = USAGE_STRINGS[choice];
                    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ahF4L.ChoiceCard), {
                        value: choice,
                        selected: meter === choice,
                        onSelect: ()=>setMeter(choice),
                        groupName: "group-usage",
                        label: label,
                        description: description,
                        list: list,
                        info: info
                    }, `usage-${choice}`);
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx2vrvc _4cvr1h6o _zulppxbi _1n261g80 _1q511wqb"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                        id: "orgUserCount-label",
                        className: (0, $2jatx.default)([
                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("label", {
                            htmlFor: "orgUserCount",
                            children: intl.formatMessage({
                                id: 'ubp.calculator.usage.orgSizeQuestion',
                                defaultMessage: 'How many people are in your organization?'
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _4cvr1h6o _zulppxbi"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("input", {
                                id: "orgUserCount",
                                type: "number",
                                value: orgUserCountInput,
                                min: 0,
                                "aria-required": "true",
                                "aria-labelledby": "orgUserCount-label",
                                onChange: (e)=>{
                                    const next = e.target.value;
                                    setOrgUserCountInput(next);
                                    setOrgUserCount(next === '' ? undefined : Number(next));
                                },
                                className: (0, $2jatx.default)([
                                    "_1bsb1lit _4t3i1ylp _1rjcu2gc _18zrpxbi _1wyb1j6v _vwz41tcg _19it79pa _2rkogktf _bfhk1afi _syazrf0c"
                                ]),
                                style: {
                                    "--_1tiihzy": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light600')),
                                    "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
                                    "--_ve8pbe": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light1100'))
                                }
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                className: (0, $2jatx.default)([
                                    "_1wyboxwj _vwz4gktf _syazrf0c"
                                ]),
                                style: {
                                    "--_ve8pbe": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light1100'))
                                },
                                children: intl.formatMessage({
                                    id: 'ubp.calculator.usage.required',
                                    defaultMessage: 'Required'
                                })
                            })
                        ]
                    })
                ]
            }),
            orgUserCountError && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1pfh1y44 _1wyb1d98 _syaz1d19 _y3gn1h6o"
                ]),
                style: {
                    "--_1ekm1f": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.secondary.red'))
                },
                children: orgUserCountError
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ehiBJ.StepNav), {
                showNext: true,
                nextDisabled: !canAdvance
            })
        ]
    });
};
// H1 title styling — extra size overrides for the Figma "D - H1 - Small" (48/56).
// TypographyStyles provides the base font-family/weight; centering + explicit
// 40px vertical padding come from Figma spec (40 above and below the H1).
const $b7809bb0a68c6442$var$pageTitleStyle = null;
// First H3 — sits above the meter/choice cards. 40px padding below per Figma;
// the H1 above supplies its own 40px bottom padding so no top padding is needed.
const $b7809bb0a68c6442$var$sectionTitleStyle = null;
// Second H3 — the "How many people..." question that sits on the SAME row as
// the org-size input. The 60px top padding lives on the parent row wrapper
// (orgSizeQuestionStyle) so the H3 and input stay vertically centered on the
// same baseline; no vertical padding is needed here.
const $b7809bb0a68c6442$var$orgSizeHeadingStyle = null;
const $b7809bb0a68c6442$var$cardGridStyle = null;
// Wraps the org-size H3 and the input+Required cluster so they sit on the same
// row — H3 immediately followed by the input + "Required" indicator. Uses a
// natural flow gap (no space-between) so the H3 and input stay adjacent, per
// Figma. 60px top padding lives on the ROW wrapper (not the H3) so both sides
// of the row shift down together and stay vertically aligned.
const $b7809bb0a68c6442$var$orgSizeQuestionStyle = null;
// Places the number input and the "Required" indicator side-by-side, with the
// label vertically centered on the input.
const $b7809bb0a68c6442$var$inputAndRequiredStyle = null;
const $b7809bb0a68c6442$var$numberInputStyle = null;
const $b7809bb0a68c6442$var$requiredLabelStyle = null;
const $b7809bb0a68c6442$var$errorMessageStyle = null;

});

parcelRegister("bIpm5", function(module, exports) {
$parcel$export(module.exports, "initialValuesFromQuery", function () { return $c5de2b8e02ebe94b$export$38fa8d283c15a6dd; });

var $cGx7y = parcelRequire("cGx7y");

var $iqmYR = parcelRequire("iqmYR");

var $kdccD = parcelRequire("kdccD");

var $73KXs = parcelRequire("73KXs");

var $9lJTH = parcelRequire("9lJTH");
const $c5de2b8e02ebe94b$var$STEP_VALUES = new Set((0, $73KXs.STEP_ORDER));
const $c5de2b8e02ebe94b$var$METER_VALUES = new Set([
    'rovoCredits',
    'automations',
    'csResolutions',
    'assetsObjects'
]);
const $c5de2b8e02ebe94b$var$USAGE_TYPE_VALUES = new Set([
    'exploring',
    'adopting',
    'scaling'
]);
const $c5de2b8e02ebe94b$export$38fa8d283c15a6dd = (search)=>{
    const parsed = (0, $kdccD.fromQueryString)(search);
    const initial = {};
    const step = $c5de2b8e02ebe94b$var$asEnum(parsed.scalars['step'], $c5de2b8e02ebe94b$var$STEP_VALUES);
    if (step) initial.step = step;
    const meter = $c5de2b8e02ebe94b$var$asEnum(parsed.scalars['meter'], $c5de2b8e02ebe94b$var$METER_VALUES);
    if (meter) initial.meter = meter;
    const usageType = $c5de2b8e02ebe94b$var$asEnum(parsed.scalars['usageType'], $c5de2b8e02ebe94b$var$USAGE_TYPE_VALUES);
    if (usageType) initial.usageType = usageType;
    const usage = $c5de2b8e02ebe94b$var$asNumber(parsed.scalars['usage']);
    if (usage !== undefined) initial.usage = usage;
    const orgUserCount = $c5de2b8e02ebe94b$var$asNumber(parsed.scalars['orgUserCount']);
    if (orgUserCount !== undefined) initial.orgUserCount = orgUserCount;
    const products = $c5de2b8e02ebe94b$var$buildProducts(parsed.arrays['products'], parsed.nested);
    if (products) initial.products = products;
    return initial;
};
const $c5de2b8e02ebe94b$var$asEnum = (value, allowed)=>value && allowed.has(value) ? value : undefined;
const $c5de2b8e02ebe94b$var$asNumber = (value)=>{
    if (value === undefined) return undefined;
    const n = Number(value);
    return Number.isFinite(n) ? n : undefined;
};
const $c5de2b8e02ebe94b$var$EDITION_VALUES = new Set((0, $73KXs.EDITION_KEYS));
/**
 * Reconstruct a single product from its config default, overriding any
 * inputs present (and valid) in the query's nested `product.<key>.*` record.
 */ const $c5de2b8e02ebe94b$var$productFromNested = (key, nested)=>{
    const base = (0, $9lJTH.buildDefaultProduct)(key);
    if (!nested) return base;
    const unitCount = $c5de2b8e02ebe94b$var$asNumber(nested['unitCount']);
    const edition = $c5de2b8e02ebe94b$var$asEnum(nested['edition'], $c5de2b8e02ebe94b$var$EDITION_VALUES) ?? base.inputs.edition;
    return {
        productKey: key,
        inputs: {
            edition: edition,
            unitCount: unitCount ?? base.inputs.unitCount,
            billingCycle: (0, $iqmYR.resolveBillingCycle)(key, edition)
        }
    };
};
const $c5de2b8e02ebe94b$var$PRODUCT_KEY_VALUES = new Set((0, $cGx7y.productPricingConfigKeys));
const $c5de2b8e02ebe94b$var$buildProducts = (selected, nested)=>{
    if (!selected) return undefined;
    const result = [];
    const seen = new Set();
    for (const raw of selected){
        const key = $c5de2b8e02ebe94b$var$asEnum(raw, $c5de2b8e02ebe94b$var$PRODUCT_KEY_VALUES);
        if (!key || seen.has(key)) continue;
        seen.add(key);
        result.push($c5de2b8e02ebe94b$var$productFromNested(key, nested[`product.${key}`]));
    }
    return result.length > 0 ? result : undefined;
};

});




//# sourceMappingURL=index.3b3f206d.js.map
